
const $ = (selector) => document.querySelector(selector);
const $$ = (selector) => document.querySelectorAll(selector);
let mobile = window.innerWidth;
let siteUrl = window.location.origin;
let red = 'rgb(255, 1, 3)'
let header = $('sticky-header.header-wrapper')

/*--------------------------------------------------------------------------------
# START JS CUSTOM HOME PAGE ||||||||||||||||||||||||||||||||||||||||||||||||||||||
--------------------------------------------------------------------------------*/

window.addEventListener("load", () => {
  window.scrollTo(0, 0);
});


if(header){
    header.classList.add('opacity-1')
}


if(document.body.classList.contains('index-custom')){

    const headerHeading = document.querySelector('.header__heading')

    if(headerHeading){
        headerHeading.setAttribute('aria-label','São Bernardo | Fábrica de Utilidades Domésticas')
        headerHeading.setAttribute('id','São Bernardo | Fábrica de Utilidades Domésticas')
    }

    $('sticky-header.header-wrapper').classList.add('p-0')

    const bannerTitle = document.querySelectorAll('h2.banner__heading.inline-richtext.h1')
    const slideControl = document.querySelector('.slideshow__controls.slider-buttons')
    const bannetText = document.querySelectorAll('.banner__text.rte p')

    if(bannetText && mobile<768){
        bannetText.forEach(b =>{
            b.classList.add('fs-5')
        })
    }

    slideControl.style.cssText = `
        transform: translateY(-60px);
        border: none;
        box-shadow: none;
        margin-bottom: -45px;
        filter: invert(1);
    `

    if(bannerTitle[0] && bannetText[0]){
        bannetText[0].classList.add('banner-text')
        bannetText[0].style.maxWidth = "420px";

        if(mobile>768){
            bannerTitle[0].style.fontSize = "5rem";            
        }else{
            bannerTitle[0].closest('.slideshow__slide').querySelector('.slideshow__media img').src = 'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/banner_02_mobile_v3.jpg?v=1764074538'
            bannerTitle[0].closest('.slideshow__slide').querySelector('.slideshow__media img').srcset = 'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/banner_02_mobile_v3.jpg?v=1764074538'            
            bannerTitle[0].style.fontSize = "3rem";
        }

        bannerTitle[0].innerHTML = `
            <span class="acumin" data-translate-key="banner_title_01">LINHA PREMIUM</span><br>
           <span class="alternate" data-translate-key="banner_title_02"> Beleza, inovação e <br>
            funcionalidade em harmonia.</span>
        `
    }

    if(bannerTitle[1] && bannetText[1]){
        bannetText[1].classList.add('banner-text')        

        if(mobile>768){
            bannerTitle[1].style.fontSize = "6rem";
        }else{
            bannerTitle[1].closest('.slideshow__slide').querySelector('.slideshow__media img').src = 'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/banner_03_mobile_v1.jpg?v=1762880784'
            bannerTitle[1].closest('.slideshow__slide').querySelector('.slideshow__media img').srcset = 'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/banner_03_mobile_v1.jpg?v=1762880784'  
            bannerTitle[1].style.fontSize = "3.5rem";
        }

        bannerTitle[1].classList.add('alternate')        
         bannerTitle[1].innerHTML = `
           <span data-translate-key="banner_title_03">Atualize sua sala com<br> design e praticidade<br></span>
           <span class="d-none d-lg-block py-5"></span>
           <span data-translate-key="banner_title_04">Mesa Lateral Retangular</span>           
        `
    }

    if(bannerTitle[2] && bannetText[2]){
        bannetText[2].classList.add('banner-text')
        bannetText[2].style.cssText = `
        text-shadow: 2px 2px 10px #000000;
        `

        bannerTitle[2].classList.add('acumin')

        bannerTitle[2].innerHTML = `
       <span data-translate-key="banner_title_05"> O BRINDE COMEÇA<br> </span> <span data-translate-key="banner_title_06">NA ELEGÂNCIA</span>
        `
        bannerTitle[2].style.cssText = `
            font-weight: 500;            
        `

         if(mobile>768){
            bannerTitle[2].style.fontSize = "6rem";
        }else{
            bannerTitle[2].closest('.slideshow__slide').querySelector('.slideshow__media img').src = 'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/banner_04_mobile_v1.jpg?v=1762880999'
            bannerTitle[2].closest('.slideshow__slide').querySelector('.slideshow__media img').srcset = 'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/banner_04_mobile_v1.jpg?v=1762880999' 
            bannerTitle[2].style.fontSize = "3.5rem";
            bannerTitle[2].style.cssText = 'text-shadow: 2px 2px 10px #000000;'
        }

        document.querySelectorAll('.banner__buttons')[2].style.cssText = `
        background-color: rgba(255,255,255,0);
        `
        document.querySelectorAll('.banner__buttons a')[2].classList = ''

        document.querySelectorAll('.banner__buttons a')[2].style.cssText = `
            background-color: rgb(255, 255, 255);
            color: rgb(0, 0, 0);
            border-radius: 50rem;
            width: 200px;
            display: flex;
            justify-content: center;
            align-items: center;
            text-decoration: none;
            font-weight: bold;
        `
    }

    const collectionTitle = document.querySelectorAll('.collection-item .collection-title')

    if(collectionTitle){
        collectionTitle.forEach((t)=>{
            if(t.textContent.trim() === 'Página inicial'){
                t.closest('.collection-item').remove()
            }
        })
    }

    const categoryItemName = document.querySelectorAll('.category-item')

    categoryItemName.forEach((c)=>{
        let dataName = c.getAttribute('data-name')
        if(c){
            c.addEventListener('click',()=>{
                window.location.href = `${siteUrl}/collections/${dataName}`
            })
        }
    })

    const formNewsLetter = document.querySelectorAll('#shopify-section-template--25682907857261__custom_liquid_CBNeP8 .field__label, #shopify-section-sections--25682908316013__custom_liquid_QAQwnb .field__label')

    if(formNewsLetter){
        formNewsLetter.forEach((f)=>{
            f.textContent = "Digite seu e-mail"
        })
    }

    document.addEventListener('DOMContentLoaded',()=>{

        const containerFade = document.querySelectorAll('.productPerView .container-fade')
     

        const seeMore = document.querySelectorAll('.see-more')
            if(seeMore){
                seeMore.forEach((f,i)=>{
                        f.addEventListener('click',()=>{
                           if(i == 0 && f){
                             window.location.href = `${siteUrl}/collections/prateleiras`
                           }
                           if(i == 1 && f){
                             window.location.href = `${siteUrl}/pages/institucional`
                           }
                           if(i == 2 && f){
                             window.location.href = `${siteUrl}/collections/all`
                           }
                           if(i == 3 && f){
                             window.location.href = `${siteUrl}/blogs/novidades`
                           }
                        })

                        f.querySelector('.text-span').setAttribute('data-translate-key','see_more_div')

                })
            }

            function equalizeHeights(selector) {
            const elements = $$(selector);
            let maxHeight = 0;            
                elements.forEach((el) => {
                    const height = el.offsetHeight;
                    if (height > maxHeight) {
                    maxHeight = height;
                    }
                });
                
                elements.forEach((el) => {
                    el.style.minHeight = `${mobile<768 ? maxHeight - maxHeight * 0.5 : maxHeight}px`;
                });
            }

            equalizeHeights('#Slider-template--25682907857261__featured_collection_KRtzTX .product-card__title')
            equalizeHeights('#Slider-template--25682907857261__featured_collection_qDGaem .product-card__title')

    })

    const videoPlayRow = document.querySelector('#video-play-row')

    if(videoPlayRow && mobile<992){
        videoPlayRow.closest('.section-template--25682907857261__custom_liquid_DqCdBY-padding').style.paddingTop = '0';
    }

}

if(document.body.classList.contains('product-custom')){

    window.addEventListener('DOMContentLoaded', ()=>{
        console.log(document.querySelector('h1').innerHTML)
    })

    const titleSwatch = document.querySelector('span.ean-color')     
    const swatchItem = document.querySelectorAll('label.swatch-input__label')     
    const eanColor = document.querySelectorAll('.ean-color');
    const swatches = document.querySelectorAll('.swatch-input__label');  

    if(window.location.href.includes('gaveteiro-gv-68-gaveteiro-plastico-3-gavetas')){     
       if(titleSwatch && titleSwatch.getAttribute('title') === 'Preto | Transparente'){        
            titleSwatch.classList.add('middle-white')
         }
    }
    
     

    eanColor.forEach(ean => {
        const eanTitle = ean.getAttribute('title');

        swatches.forEach(swatch => {
            const swatchTitle = swatch.getAttribute('title');

            if (eanTitle === swatchTitle) {
                const swatchContent = swatch.querySelector('.swatch');

                if (swatchContent) {
                    ean.style.cssText = swatchContent.style.cssText;
                    ean.classList.add('swatch')
                }
            }
        });
    });



    const prodVolume =  document.querySelectorAll('.product__info-container .card-prod-volume')

    if(prodVolume.length>0){
        prodVolume.forEach(item =>{
            item.classList.remove('d-none');
        })
    }

    headerDefault()

    const shareButton = $('#share-button')

    if(shareButton && $('.share-button__button')){
        $('.share-button__button').style.display = 'none';
        shareButton.addEventListener('click',()=>{
            $('.share-button__button').click()
        })
    }

    function equalizeHeights(selector) {
    const elements = Array.from(document.querySelectorAll(selector));

    // 1. Encontra a altura máxima usando reduce
    const maxHeight = elements.reduce((max, el) => {
        // Primeiro, removemos qualquer min-height existente para obter a altura natural
        el.style.minHeight = '0px'; 
        const height = el.offsetHeight;
        return height > max ? height : max;
    }, 0);

        // 2. Aplica a nova altura mínima a todos os elementos
        elements.forEach((el) => {
            if(mobile>992){
                el.style.height = `${maxHeight * 1.8}px`;
            }else{
                el.style.height = `${maxHeight * 1.25}px`;
            }
        });
    }

    // Exemplo de uso
    equalizeHeights('.swiper .product-card__info .product-card__link');


    const tabelaProduto = $('.tabela-produto')

    if(tabelaProduto.textContent.trim() == ''){
        if(tabelaProduto){
            tabelaProduto.closest('section').style.display = 'none';
        }
    }

    if($('.productPerView .swiper-wrapper').innerHTML == '' && $('.productPerView .swiper-wrapper')){
        $('.productPerView .swiper-wrapper').closest('section').style.display = 'none'
    }

    const productCard = document.querySelectorAll('product-info .product-card__info')

    if(productCard.length>0){
        productCard.forEach(card =>{
            card.classList.remove('d-grid');
        })
    }

    const lineCollection = document.querySelector('.line-collection')

    if(lineCollection){
        if(window.location.href.includes('embalagem-cab-03-20pcs-cabides-plasticos')){
            lineCollection.textContent = 'EMBALAGEM'
        }
    }

}

if(document.body.classList.contains('collection-custom')){

    headerDefault()

    if(window.location.href.includes('/collections/produtos')){
        window.location.href = `${siteUrl}/collections/all`
    }

    const linkItemCollection = document.querySelectorAll('.collection-item.swiper-slide a')

   if(linkItemCollection){
        linkItemCollection.forEach(a =>{

            if(a.href.includes('/collections/produtos')){
                    a.href = '/collections/all'
                }

        })
   }
    
    let navPagination = document.querySelectorAll('.pagination__item')

    if(navPagination){
        navPagination.forEach(pag =>{
            if(!pag.classList.contains('pagination__item--current')){
                pag.classList.add('no-current')
            }
        })
    }

    if(mobile<=990){

        const fruteira = document.querySelector('.fruteira')
        const cozinha = document.querySelector('.cozinha')
        const cabide = document.querySelector('.cabide')
        const gaveteiros = document.querySelector('.gaveteiros')
        const pipoqueiras = document.querySelector('.pipoqueiras')
        const copos = document.querySelector('.copos')
        const garrafas = document.querySelector('.garrafas')
        const linhaPremium = document.querySelector('.linha-premium')
        const prateleiras = document.querySelector('.prateleiras')
        const portaCosmeticos = document.querySelector('.porta-cosmeticos')
        const organizadores1 = document.querySelector('.organizadores-1')
        const lancamentos = document.querySelector('.lancamentos')
        const organizadores = document.querySelector('.organizadores')
        const caixaUtilidades = document.querySelector('.caixa-de-utilidades')
        const pet = document.querySelector('.pet')

        if(fruteira || organizadores){            
            document.querySelector('.bottle-mobile-collection').style.backgroundPosition = "65% center" ;  
        }
        if(lancamentos){            
            document.querySelector('.bottle-mobile-collection').style.backgroundPosition = "55% center" ;  
        }
        if(pipoqueiras){            
            document.querySelector('.bottle-mobile-collection').style.backgroundPosition = "75% center" ;  
        }
        if(cozinha || cabide){      
            document.querySelector('.bottle-mobile-collection').style.backgroundPosition = "50% center" ;  
        }
        if(gaveteiros || copos){      
            document.querySelector('.bottle-mobile-collection').style.backgroundPosition = "70% center" ;  
        }
        if(pet){      
            document.querySelector('.bottle-mobile-collection').style.backgroundPosition = "71% center" ;  
        }
        if(garrafas){      
            document.querySelector('.bottle-mobile-collection').style.backgroundPosition = "74% center" ;  
        }
        if(prateleiras || portaCosmeticos){      
            document.querySelector('.bottle-mobile-collection').style.backgroundPosition = "90% center" ;  
        }
        if(linhaPremium){      
            document.querySelector('.bottle-mobile-collection').style.backgroundPosition = "92% center" ;  
        }
        if(organizadores1 || caixaUtilidades){      
            document.querySelector('.bottle-mobile-collection').style.backgroundPosition = "50% center" ;  
        }
    }

   
           function equalizeHeight(selector) {
                const elements = document.querySelectorAll(selector);
                if (!elements.length) return;

                let maxHeight = 0;

                elements.forEach(el => {
                    el.style.height = 'auto'; // reseta antes de medir
                    const height = el.offsetHeight;
                    if (height > maxHeight) {
                        maxHeight = height;
                    }
                });

                elements.forEach(el => {
                    el.style.minHeight = `${maxHeight * 1.25}px`;
                });
            }


            equalizeHeight('.product-card__info.d-grid .product-card__link')


            const collectionItemSwiper = document.querySelectorAll('.collection-item.swiper-slide');

                    document.addEventListener('DOMContentLoaded', () => {
                        if (collectionItemSwiper.length > 1) {
                            collectionItemSwiper.forEach((item) => {
                                const img = item.querySelector('img');
                                if (!img) return;
                                const url = img.src;
                                if (url.includes('no-image')) {
                                    const parent = img.closest('.collection-item.swiper-slide');
                                    parent.style.display = 'none'
                                        }
                                    });
                                }
                            });


}

if(document.body.classList.contains('page-fale-conosco-custom')){

    const formSelect = document.querySelector('#formulario-contato')

        if(formSelect){
            formSelect.remove()
        }

    headerDefault()

    let richtextHeding =  document.querySelector('h2.rich-text__heading')
    
    if(richtextHeding){
        richtextHeding.innerHTML = `
            <span>Seja um Revendedor São Bernardo</span><br>
            <span class="fs-1">– Qualidade que Gera Confiança e Resultados</span>
        `
    }

    let selectField = document.querySelectorAll('select.field__input')

    if(selectField){
        selectField.forEach(select =>{
            select.style.padding = '1rem 1.5rem .8rem 2rem';
        })
    }

}

if(document.body.classList.contains('page-contato-custom')){

        const formSelect = document.querySelector('#formulario-revenda')

        if(formSelect){
            formSelect.remove()
        }

       headerDefault()

        const formularioContato = document.querySelector('#formulario-contato')

        if(formularioContato){
            formularioContato.closest('.page-width').classList.add('max-width-md-xl')
        }

}

if(document.body.classList.contains('blog-custom') || document.body.classList.contains('article-custom')){
    headerDefault()

    function normalizeTag(selector) {
        const el = document.querySelector(selector);
        if (!el) return;

        let text = el.innerText.toLowerCase().trim();
        if (!text) return;

        // separa as palavras e capitaliza cada uma
        let formatted = text
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");

        el.innerText = formatted;
    }


    normalizeTag('.current-tags-low')

    const cardInformation = document.querySelectorAll('.card__information')
    
    if(cardInformation){
        cardInformation.forEach(btn =>{

            const buttonSeeMore = document.createElement('button')

            buttonSeeMore.innerHTML = `Leia Mais`

            btn.appendChild(buttonSeeMore)
        })
    }

    const blogTags = document.querySelectorAll('.blog-tags li a')

    if(blogTags.length>0){
        blogTags.forEach(a =>{
                a.closest('li').addEventListener('mouseover',()=>{
                    a.style.color = '#ffffff'
                })
                a.closest('li').addEventListener('mouseout',()=>{
                    a.style.color = '#000000'
                })
        })
    }

    const swperSlideBlog = document.querySelectorAll('.swiper-slide')

    if(swperSlideBlog.length>0){
        document.querySelector('.carousel-related-blog').classList.remove('d-none');
        document.querySelector('.carousel-related-blog').style.marginBottom = '40px';
    }

    const lastPostContent = document.querySelector('.last-post-content')

    if(lastPostContent){
        if(mobile<768){
            lastPostContent.querySelector('h2').classList.replace('fs-2','fs-3');
            if(lastPostContent.querySelector('p')){
                lastPostContent.querySelector('p').classList.replace('fs-4','fs-5');
            }            
        }
    }

} 

if(document.body.classList.contains('page-politica-de-qualidade-custom')){
            
            headerDefault()

            const mainPageTitle = document.querySelector('h2.rich-text__heading')

            if(mainPageTitle){
                mainPageTitle.closest('section').classList.add('banner-politica-qualidade');
                mainPageTitle.closest('.rich-text').classList.remove('gradient','color-scheme-1');
            }

}

if(document.body.classList.contains('page-faq-custom') || document.body.classList.contains('page-termos-e-condicoes-de-uso-custom') || document.body.classList.contains('page-politica-de-privacidade-custom') || document.body.classList.contains('article-custom') || document.body.classList.contains('search-custom') ){
    headerDefault()
}

if(document.body.classList.contains('list-collections-custom')){

    headerDefault()

    const imgs = document.querySelectorAll('img')

    if(imgs){
        imgs.forEach(img =>{
            img.style.cssText = 'transform: scale(1);'
        })
    }


    const links = document.querySelectorAll('.card__heading a')

    const titlePage = document.querySelector('h1.title.title--primary')
    if(titlePage){
        titlePage.style.display = 'none';
    }

    const cardContent = document.querySelectorAll('.card__content')

    if(cardContent){
        cardContent.forEach(c =>{
            c.style.cssText = `
                position: relative;             
                margin-bottom: -20px;  
                cursor: pointer;                           
            `

            if(c.querySelector('a.full-unstyled-link').href.includes('/collections/produtos')){
                c.querySelector('a.full-unstyled-link').href = '/collections/all'
            }

            if(mobile<768){
                c.style.cssText = `
                    padding-left: 5px;
                `
            }else{
                c.style.cssText = `
                    padding-left: 20px;
                    cursor: pointer;    
                `
            }

           if(mobile>992){
             c.querySelector('a.full-unstyled-link').style.cssText = `              
                font-weight: bold;
                color: #ffffff;
                text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.75);
                position: relative;
                top: -60px;
                font-size: clamp(0.85em, 2vw, 2rem);
            `
           }else{

            if(
             c.querySelector('a.full-unstyled-link').textContent.trim() === 'Caixa de utilidades' || 
             c.querySelector('a.full-unstyled-link').textContent.trim() === 'Porta Cosméticos' ||
             c.querySelector('a.full-unstyled-link').textContent.trim() === 'Caixas Decoradas' ||
             c.querySelector('a.full-unstyled-link').textContent.trim() === 'Caixa de Ferramenta'
             ){
                c.style.maxWidth = '140px'
            }

             c.querySelector('a.full-unstyled-link').style.cssText = `              
                font-weight: bold;
                color: #000000;                
                position: relative;                
                font-size: clamp(0.88em, 2vw, 2rem);
            `
           }

            c.addEventListener('click',()=>{
                 c.querySelector('a.full-unstyled-link').click()
            })
        })

        document.querySelectorAll('.card__inner .media').forEach(m =>{
            m.style.borderRadius = '20px';
        })
        document.querySelectorAll('.card__inner .card__media').forEach(m =>{
            m.style.backgroundColor = '#ffffff';
        })
    }

}

if(document.body.classList.contains('search-custom')){

    const searchBtn = document.querySelectorAll('button.search__button.field__button')

    if(searchBtn){
        searchBtn.forEach(btn =>{
            btn.innerHTML = `
            <span class="svg-wrapper"><svg fill="none" class="icon icon-search" viewBox="0 0 18 19" style="opacity: 1;">
                    <path fill="currentColor" fill-rule="evenodd"
                        d="M11.03 11.68A5.784 5.784 0 1 1 2.85 3.5a5.784 5.784 0 0 1 8.18 8.18m.26 1.12a6.78 6.78 0 1 1 .72-.7l5.4 5.4a.5.5 0 1 1-.71.7z"
                        clip-rule="evenodd"></path>
                </svg>
            </span>
            `
        })
    }

    const blogSearch = document.querySelectorAll('.article-card-wrapper')

    if(blogSearch.length>0){
        blogSearch.forEach(blog =>{
            blog.closest('li').remove()
        })
    }

      function equalizeHeights(selector) {
            const elements = $$(selector);
            let maxHeight = 0;            
                elements.forEach((el) => {
                    const height = el.offsetHeight;
                    if (height > maxHeight) {
                    maxHeight = height;
                    }
                });
                
                elements.forEach((el) => {
                    el.style.minHeight = `${maxHeight}px`;
                });
            }

            // equalizeHeights('.search-custom ul.grid li')
            equalizeHeights('.search-custom .product-card-custom')
}

if(document.body.classList.contains('page-termos-e-condicoes-de-uso-custom')){

    const iconsArray = [
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/1-icone-termos.png?v=1763748697',
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/2-icone-termos.png?v=1763748697',
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/3-icone-termos.png?v=1763748697',
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/4-icone-termos.png?v=1763748697',
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/5-icone-termos.png?v=1763748697',
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/6-icone-termos.png?v=1763748697',
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/7-icone-termos.png?v=1763748697',
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/8-icone-termos.png?v=1763748697',
    ]

    const icons = document.querySelectorAll('.icon-terms')

    if(icons){
        icons.forEach((icon,i) =>{
            icon.innerHTML = `
            <img src="${iconsArray[i]}"
            alt="Icone Termos de Uso São Bernardo" width="35" height="35"
            class="img-fluid">
            `
        })
    }

}

if(document.body.classList.contains('page-politica-de-privacidade-custom')){

    const iconsArray = [
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/1-icone-politicas.png?v=1763747805',
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/2-icone-politicas.png?v=1763747805',
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/3-icone-politicas.png?v=1763747805',
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/4-icone-politicas.png?v=1763747805',
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/5-icone-politicas.png?v=1763747805',
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/6-icone-politicas.png?v=1763747805',
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/7-icone-politicas.png?v=1763747805',
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/8-icone-politicas.png?v=1763747805',
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/9-icone-politicas.png?v=1763747805',
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/10-icone-politicas.png?v=1763747805',
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/11-icone-politicas.png?v=1763747805',
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/12-icone-politicas.png?v=1763747805',
    'https://cdn.shopify.com/s/files/1/0956/4202/6349/files/13-icone-politicas.png?v=1763747805']

    const icons = document.querySelectorAll('.icon-terms')

    if(icons){
        icons.forEach((icon,i) =>{
            icon.innerHTML = `
            <img src="${iconsArray[i]}"
            alt="Icone Políticas de Privacidade São Bernardo" width="35" height="35"
            class="img-fluid">
            `
        })
    }

}

if(document.body.classList.contains('page-institucional-custom')){
    const bannerTitle = document.querySelector('h2.banner__heading.inline-richtext.h1')
    const bannerText = document.querySelector('.banner__text.rte.subtitle p')
   if(mobile>992){

     bannerText.innerHTML = `
        Cada produto tem uma história.<br>
        A nossa começa com você.
        `
   }else{
    bannerText.innerHTML = `
        Cada produto tem<br> uma história.<br>
        A nossa começa<br> com você.
        `
        bannerTitle.innerHTML = `
        Bem-vindo à Empresa<br> São Bernardo.
        `
   }

}

if(document.body.classList.contains('page-montagem-custom')){
    headerDefault()
}

if(document.body.classList.contains('page-sustentabilidade-custom')){
    headerDefault()

    const textBanner = document.querySelector('.banner__text.rte.body p')
    const imageWithText = document.querySelector('#ImageWithText--template--26482536644973__image_with_text_McrgU4')
    const textBannerBottom = document.querySelector('#Banner-template--26482536644973__image_banner_cWQXyJ .banner__text.rte.body p')

    if(textBanner){
        if(mobile>992){
            textBanner.innerHTML = `
        <span class="fs-1" data-translate-key="social_responsibility">RESPONSABILIDADE SOCIAL</span><br><br>

<span class="fs-3" data-translate-key="company_foundation_paragraph">Fundada em 1959, a São Bernardo é referência no mercado plástico quanto a inovação e qualidade de utilidades domésticas, embalagens alimentícias e industriais.</span><br><br>

<span class="fs-3" data-translate-key="technology_and_quality_paragraph">Com tecnologia de ponta e o que há de melhor e mais moderno em equipamentos de injeção plástica e sistema de gestão da qualidade, atendemos as mais diversas necessidades exigências e expectativas do mercado, resultando no desenvolvimento de produtos diferenciados e uma parceria sólida com seus clientes.</span>
        `
        }else{
            textBanner.innerHTML = `
        <span class="fs-2" data-translate-key="social_responsibility">RESPONSABILIDADE SOCIAL</span><br><br>

<span class="fs-5" data-translate-key="company_foundation_paragraph">Fundada em 1959, a São Bernardo é referência no mercado plástico quanto a inovação e qualidade de utilidades domésticas, embalagens alimentícias e industriais.</span><br><br>

<span class="fs-5" data-translate-key="technology_and_quality_paragraph">Com tecnologia de ponta e o que há de melhor e mais moderno em equipamentos de injeção plástica e sistema de gestão da qualidade, atendemos as mais diversas necessidades exigências e expectativas do mercado, resultando no desenvolvimento de produtos diferenciados e uma parceria sólida com seus clientes.</span>
        `
        }
    }

    if(imageWithText){
        imageWithText. innerHTML = `        
        <h2 class="image-with-text__heading inline-richtext fs-1" data-translate-key="sustainability_applied_to_production_excellence_title">
                    Sustentabilidade aplicada à excelência produtiva
                  </h2>
        <div class="image-with-text__text rte body" data-translate-key="sustainability_applied_to_production_excellence_paragraph">
                    <p class="fs-4">A São Bernardo oferece acompanhamento técnico em todas as etapas de desenvolvimento e produção do produto feito sob medida de acordo com as necessidades do cliente. Em cada etapa são aplicados controles de qualidade em conformidade com a nossa norma ISO 9001:2015 e normas de BPF (Boas Práticas de Fabricação) de modo a garantir a qualidade. Seu portifólio de produtos é extenso e atende a diversas demandas e necessidades do mercado.</p>
        </div>

        <h2 class="image-with-text__heading inline-richtext fs-1" data-translate-key="quality_sustained_by_people_processes_and_trust_title">
                    Qualidade que se sustenta em pessoas, processos e confiança
                  </h2>
        <div class="image-with-text__text rte body" data-translate-key="quality_sustained_by_people_processes_and_trust_paragraph">
                    <p class="fs-4">Com uma equipe multidisciplinar, e especializada e atualizada com o que há de melhor no mercado em termos de qualidade e segurança de embalagens, os produtos são reconhecidamente seguros e de qualidade. Por meio do controle do processo produtivo, testes rigorosos e acompanhamento constante pela equipe técnica a excelência é alcançada e assegurada além de atender os requisitos dos clientes. </p>
        </div>

        `
    }

    if(textBannerBottom){
        if(mobile>992){
            textBannerBottom.innerHTML = `
            <span class="fw-bold" style="
                font-size: 3.5rem;
                line-height: 1.2;
                max-width: 530px;
            " data-translate-key="company_full_name">Empresa Mecânica e<br>
                Estamparia São Bernardo.</span><br>

                <span class="fs-2" data-translate-key="sustainability_quote">”O futuro depende das escolhas que fazemos hoje.” </span><br>

                <span class="fs-2" data-translate-key="sustainability_statement_paragraph">Desta forma escolhemos contribuir com
                a sustentabilidade, para garantir um amanhã
                melhor  para todos.</span>
        `
        }else{
            textBannerBottom.innerHTML = `
            <span class="fw-bold" style="
                font-size: 2rem;
                line-height: 1.2;
            " data-translate-key="company_full_name">Empresa Mecânica e<br>
                Estamparia São Bernardo.</span><br>

                <span class="fs-4" data-translate-key="sustainability_quote">”O futuro depende das<br> escolhas que fazemos hoje.” </span><br>

                <span class="fs-4" data-translate-key="sustainability_statement_paragraph">Desta forma escolhemos contribuir com
                a sustentabilidade, para garantir um amanhã
                melhor  para todos.</span>
             `
        }
    }

    if(mobile<992){

        if($('#Banner-template--26482536644973__image_banner_fAQaFH')){
            $('#Banner-template--26482536644973__image_banner_fAQaFH').classList.remove('banner--adapt','banner--mobile-bottom')
            $('#Banner-template--26482536644973__image_banner_fAQaFH').style.cssText = `
            min-height: 570px;
            padding: 0 10px;
            `
        }

        if($('div#ImageWithText--template--26482536644973__image_with_text_McrgU4')){
            $('div#ImageWithText--template--26482536644973__image_with_text_McrgU4').style.cssText = `
                padding: 20px 10px 0 10px;
            `
        }

        if($('#Banner-template--26482536644973__image_banner_cWQXyJ')){
                $('#Banner-template--26482536644973__image_banner_cWQXyJ').classList.remove('banner--mobile-bottom');
                $('#Banner-template--26482536644973__image_banner_cWQXyJ').style.cssText = `
                min-height: 520px;
                `
        }

        if($('#Banner-template--26482536644973__image_banner_cWQXyJ .banner__text.rte.body p')){
            $('#Banner-template--26482536644973__image_banner_cWQXyJ .banner__text.rte.body p').classList.add('d-grid')
        }

         $$('.banner__content').forEach((banner)=>{
            banner.classList.replace('banner__content--middle-left','banner__content--middle-center')
            banner.classList.replace('banner__content--top-left','banner__content--middle-center')
        })

        $('#shopify-section-template--26482536644973__image_with_text_McrgU4 .image-with-text__grid').classList.replace('grid--2-col-tablet','grid--1-col-tablet')

    }

    if(mobile>576 && mobile<1439){
         $$('.banner__content').forEach((banner)=>{
            banner.style.padding = "50px"
        })
    }

}

/*--------------------------------------------------------------------------------
# START JS GLOBAL ||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||
--------------------------------------------------------------------------------*/

const swatchColor = document.querySelectorAll('.color-swatch');

document.addEventListener('DOMContentLoaded',()=>{

    if (swatchColor.length > 0) {
        swatchColor.forEach(swatch => {
            const bgColor = getComputedStyle(swatch).backgroundColor;           
            
            if (swatch.getAttribute('title') === 'Verde' && bgColor === 'rgb(204, 204, 204)'){
                swatch.classList.add('swatch-green')
            }
            if (swatch.getAttribute('title') === 'Branco' && bgColor === 'rgb(204, 204, 204)'){
                swatch.classList.add('swatch-white')
            }
            if (swatch.getAttribute('title') === 'Cinza Concreto' && bgColor === 'rgb(204, 204, 204)'){
                swatch.classList.add('swatch-gray')
            }
        });
    }

})


const eanText = document.querySelectorAll('.ean-text')

if(eanText.length>0){
    eanText.forEach(ean =>{

        let eanFormated = ean.textContent.trim()

        if(eanFormated === 'CÓDIGO EAN:'){
            ean.closest('.variation-ean-item').style.display = 'none'
        }   

    })
}

const titleCard = document.querySelectorAll('.product-card__title, .product__title h1');

if (titleCard.length > 0) {
    titleCard.forEach(el => {
        const regex = / \//g;
        const texto = el.innerHTML.trim();

        if (regex.test(texto)) {
        el.innerHTML = texto.replace(regex, '<br>');
        }
    });
}


const palavras = ['alto', 'raso'];

function removerPalavras(el, palavrasRemover) {
    let texto = el.innerHTML;

    palavrasRemover.forEach(palavra => {
        // cria regex dinâmica para remover apenas a palavra exata
        const regex = new RegExp(`\\b${palavra}\\b`, 'gi');
        texto = texto.replace(regex, '').replace(/\s+/g, ' ').trim();
    });

    el.innerHTML = texto;
}

titleCard.forEach(el => removerPalavras(el, palavras));


const blog = document.querySelector('.blog ')

    if(blog){
    const blogTitle = document.querySelector('.blog__title').closest('.title-wrapper-with-link')
    const blogContainer = document.querySelector('.blog__title').closest('.page-width-desktop')
    const blogDescription = document.querySelectorAll('.blog__posts p.article-card__excerpt')
    const blogCard = document.querySelectorAll('.blog__posts .card__inner')
    const blogLink = document.querySelectorAll('.blog__posts h3.card__heading.h2 a')
    

    if(blog && mobile<992){
        blog.querySelector('.slider-buttons').style.display = 'none';
    }

      

    if(blogContainer && mobile > 992){
       
        if(document.body.classList.contains('index-custom')){
             blogContainer.style.padding = "0";

             if(blogDescription){
                blogDescription.forEach((b)=>{
                    b.style.display = "block";
                })
             }
        }else{
            if(document.body.classList.contains('index-custom')){
                 blogContainer.style.padding = "35px 0";
            }
        }

        blogContainer.style.maxWidth = "1320px"
    }

    if(mobile<992){
        if(document.body.classList.contains('index-custom')){
            blogTitle.closest('.page-width-desktop').style.paddingTop = '0';
        }
    }

    if(blogTitle){

        blogTitle.innerHTML = `
           <div class="col-auto">
            <h2 class="p-0 m-0">
                <strong data-translate-key="blog_latest_title" class="d-block" ${mobile>992 ? 'style="max-width: 355px;" ' : ''}>
                    Últimos Artigos & Notícias<br> do Blog
                </strong>
            </h2>                  
            </div>

            <div class="col-auto d-none d-lg-block">
                <div class="see-more align-items-end">
                    <a href="${siteUrl}/blogs/novidades"><span class="text-span">Ver mais posts</span></a>
                    <span class="svg-span">
                        <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path d="M5 12H19M5 12L11 6M5 12L11 18" stroke="#ab0102" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round"></path>
                            </g>
                        </svg>
                    </span>
                </div>
            </div>
        `
    }  

    if(blogCard){
        blogCard.forEach((b)=>{
            b.style.backgroundColor = "rgba(255,255,255,0)"
            b.querySelector('.card__information').style.padding = "0"

            b.querySelector('img').classList.add('lazy-transition')
            b.querySelector('img').classList.remove('motion-reduce')
        }) 
    }

    if(blogLink){
        blogLink.forEach(a =>{

            a.closest('h3').style.cssText = `
                font-size: 1.75rem;
                font-weight: bold;
            `

            a.style.textDecoration = "none";

            let buttonSeeMore = document.createElement('div')
            buttonSeeMore.innerHTML = `
                <div class="see-more align-items-end">
                        <span class="text-span">Leia Mais</span>
                        <span class="svg-span">
                            <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path d="M5 12H19M5 12L11 6M5 12L11 18" stroke="#ab0102" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                </g>
                            </svg>
                        </span>
                    </div>
            `

            a.appendChild(buttonSeeMore)

        })
    }
    
}


function headerDefault(){
    if(header){
        header.style.cssText = `
            position: relative;     
            background-color: ${red};    
        `
    }
}
    

const logoContainer = document.querySelector('.header__heading-logo-wrapper')
const div = document.createElement('div')
div.innerHTML = `<span data-translate-key="header_announcement">Soluções que simplificam sua vida.</span>`
div.classList.add('logo-text','mt-3')
logoContainer.appendChild(div)

/*--------------------------------------------------------------------------------
# HEADER JS GLOBAL |||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||
--------------------------------------------------------------------------------*/


const imgs = document.querySelectorAll('img')

if(imgs){
    imgs.forEach((img)=>{
        img.classList.add('no-select')
    })
}

const headerSearch = document.querySelector('details-modal.header__search')
headerSearch.remove()

    const iconAccount = document.querySelector('a.header__icon.header__icon--account.link.focus-inset.small-hide')
    iconAccount.style.textDecoration = 'none';
    iconAccount.src = ''
    iconAccount.remove()

    const icconCart = document.querySelector('a#cart-icon-bubble')
    if(icconCart){
            icconCart.src = ''
            icconCart.addEventListener('click',(e)=>{
                e.preventDefault()
            })
            icconCart.remove()
    }

    const headerIcons = document.querySelector('.header__icons')

    headerIcons.classList.replace('header__icons','header__icons_custom')


const headerContainer = document.querySelector('sticky-header.header-wrapper')
const logoText = document.querySelector('.logo-text')
const linkItem = document.querySelectorAll('ul.list-menu li a, .flag')

headerContainer.classList.remove('gradient','color-scheme-1');
headerContainer.classList.add('header-trasition','header-top');
logoText.classList.add('header-trasition');


const arrayPages = ['page-sustentabilidade-custom','page-montagem-custom','list-collections-custom','collection-custom','search-custom','product-custom', 'page-fale-conosco-custom', 'page-contato-custom', 'page-politica-de-qualidade-custom','page-faq-custom','page-termos-e-condicoes-de-uso-custom','page-politica-de-privacidade-custom','blog-custom','article-custom'];

if (!arrayPages.some(cls => document.body.classList.contains(cls))) {
    headerContainer.classList.add('header-top-gradient');
    }

window.addEventListener('scroll',()=>{

    let scrollY = window.scrollY

    if(scrollY>30){
         headerContainer.classList.add('header-scroll')
         headerContainer.classList.remove('header-top')
         headerContainer.classList.remove('header-top-gradient')
         headerContainer.style.top = "0"
         logoText.style.display = "none"

         linkItem.forEach((a)=>{
            a.classList.add('invert')
         })

         if(mobile<992){
            document.querySelectorAll('ul.menu-drawer__menu.has-submenu.list-menu li a').forEach(item =>{
                item.style.cssText = "filter: invert(0)"
            })
         }

    }else{
         headerContainer.classList.add('header-top')
         
         if (!arrayPages.some(cls => document.body.classList.contains(cls))) {
                headerContainer.classList.add('header-top-gradient');
            }

         headerContainer.classList.remove('header-scroll')   


       function topHeader(selectors){
            const bodyClasses = document.body.classList;
            let match = false;

            selectors.forEach(cls => {
                if (bodyClasses.contains(cls)) match = true;
            });

                if(mobile>=992){
                    headerContainer.style.top = match ? "0" : "0";
                }
            }

            topHeader(['page-sustentabilidade-custom','page-montagem-custom','list-collections-custom','collection-custom','search-custom','product-custom', 'page-fale-conosco-custom', 'page-contato-custom', 'page-politica-de-qualidade-custom','page-faq-custom','page-termos-e-condicoes-de-uso-custom','page-politica-de-privacidade-custom','blog-custom','article-custom']);
       
         logoText.style.display = "block"

            linkItem.forEach((a)=>{
            if(a.classList.contains('invert')){
                a.classList.remove('invert')
            }
         })
    }

})

const copyFooterBlock = document.querySelector('.copy-footer-block')

if(copyFooterBlock){
    copyFooterBlock.innerHTML = `
        <ul class="footer-block__details-content list-unstyled">
                        <li>
                            <a href="mailto:atendimento@saobernardo.ind.br?cc=saobernardo@saobernardo.ind.br" class="link link--text list-menu__item list-menu__item--link p-0 m-0 d-flex align-items-center mb-3">
                                <span class="d-block">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" zoomAndPan="magnify" viewBox="0 0 37.5 37.500001" height="15" preserveAspectRatio="xMidYMid meet" version="1.2"><defs><clipPath id="c183493e8b"><path d="M 0 5 L 37.007812 5 L 37.007812 29.605469 L 0 29.605469 Z M 0 5 "></path></clipPath></defs><g id="4c9b6a21bd"><path style=" stroke:none;fill-rule:nonzero;fill:#ffffff;fill-opacity:1;" d="M 18.503906 14.582031 L 36.511719 3.332031 C 36.292969 2.835938 36.007812 2.382812 35.65625 1.96875 C 35.308594 1.558594 34.90625 1.203125 34.453125 0.910156 C 34 0.613281 33.511719 0.386719 32.992188 0.234375 C 32.476562 0.078125 31.945312 0 31.402344 0 L 5.601562 0 C 5.066406 0 4.539062 0.078125 4.023438 0.230469 C 3.507812 0.382812 3.023438 0.605469 2.574219 0.898438 C 2.121094 1.191406 1.722656 1.539062 1.371094 1.945312 C 1.019531 2.355469 0.734375 2.800781 0.511719 3.292969 Z M 18.503906 14.582031 "></path><g clip-rule="nonzero" clip-path="url(#c183493e8b)"><path style=" stroke:none;fill-rule:nonzero;fill:#ffffff;fill-opacity:1;" d="M 19.15625 17.082031 C 18.957031 17.207031 18.738281 17.269531 18.503906 17.269531 C 18.265625 17.269531 18.046875 17.207031 17.847656 17.082031 L 0 5.882812 L 0 24.003906 C 0 24.371094 0.0351562 24.734375 0.109375 25.09375 C 0.179688 25.457031 0.285156 25.804688 0.429688 26.144531 C 0.570312 26.484375 0.742188 26.808594 0.945312 27.113281 C 1.148438 27.417969 1.382812 27.703125 1.640625 27.960938 C 1.902344 28.222656 2.183594 28.457031 2.492188 28.660156 C 2.796875 28.863281 3.1216094 29.035156 3.460938 29.175781 C 3.800781 29.316406 4.148438 29.425781 4.511719 29.496094 C 4.871094 29.570312 5.234375 29.605469 5.601562 29.605469 L 31.402344 29.605469 C 31.773438 29.605469 32.136719 29.570312 32.496094 29.496094 C 32.855469 29.425781 33.207031 29.316406 33.546875 29.175781 C 33.886719 29.035156 34.210938 28.863281 34.515625 28.660156 C 34.820312 28.457031 35.105469 28.222656 35.363281 27.960938 C 35.625 27.703125 35.855469 27.417969 36.0625 27.113281 C 36.265625 26.808594 36.4375 26.484375 36.578125 26.144531 C 36.71875 25.804688 36.824219 25.457031 36.898438 25.09375 C 36.96875 24.734375 37.007812 24.371094 37.007812 24.003906 L 37.007812 5.925781 Z M 19.15625 17.082031 "></path></g></g></svg>
                                </span>
                                <span class="d-block position-relative text-white" style="top: -3px;">
                                    atendimento@saobernardo.ind.br
                                </span>
                            </a>
                        </li>
                        <li class="mb-5 d-none">
                              <a href="mailto:saobernardo@saobernardo.ind.br" class="link link--text list-menu__item list-menu__item--link p-0 m-0 d-flex align-items-center">
                                <span class="d-block" style="opacity:0;">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" zoomAndPan="magnify" viewBox="0 0 37.5 37.500001" height="15" preserveAspectRatio="xMidYMid meet" version="1.2"><defs><clipPath id="c183493e8b"><path d="M 0 5 L 37.007812 5 L 37.007812 29.605469 L 0 29.605469 Z M 0 5 "></path></clipPath></defs><g id="4c9b6a21bd"><path style=" stroke:none;fill-rule:nonzero;fill:#ffffff;fill-opacity:1;" d="M 18.503906 14.582031 L 36.511719 3.332031 C 36.292969 2.835938 36.007812 2.382812 35.65625 1.96875 C 35.308594 1.558594 34.90625 1.203125 34.453125 0.910156 C 34 0.613281 33.511719 0.386719 32.992188 0.234375 C 32.476562 0.078125 31.945312 0 31.402344 0 L 5.601562 0 C 5.066406 0 4.539062 0.078125 4.023438 0.230469 C 3.507812 0.382812 3.023438 0.605469 2.574219 0.898438 C 2.121094 1.191406 1.722656 1.539062 1.371094 1.945312 C 1.019531 2.355469 0.734375 2.800781 0.511719 3.292969 Z M 18.503906 14.582031 "></path><g clip-rule="nonzero" clip-path="url(#c183493e8b)"><path style=" stroke:none;fill-rule:nonzero;fill:#ffffff;fill-opacity:1;" d="M 19.15625 17.082031 C 18.957031 17.207031 18.738281 17.269531 18.503906 17.269531 C 18.265625 17.269531 18.046875 17.207031 17.847656 17.082031 L 0 5.882812 L 0 24.003906 C 0 24.371094 0.0351562 24.734375 0.109375 25.09375 C 0.179688 25.457031 0.285156 25.804688 0.429688 26.144531 C 0.570312 26.484375 0.742188 26.808594 0.945312 27.113281 C 1.148438 27.417969 1.382812 27.703125 1.640625 27.960938 C 1.902344 28.222656 2.183594 28.457031 2.492188 28.660156 C 2.796875 28.863281 3.1216094 29.035156 3.460938 29.175781 C 3.800781 29.316406 4.148438 29.425781 4.511719 29.496094 C 4.871094 29.570312 5.234375 29.605469 5.601562 29.605469 L 31.402344 29.605469 C 31.773438 29.605469 32.136719 29.570312 32.496094 29.496094 C 32.855469 29.425781 33.207031 29.316406 33.546875 29.175781 C 33.886719 29.035156 34.210938 28.863281 34.515625 28.660156 C 34.820312 28.457031 35.105469 28.222656 35.363281 27.960938 C 35.625 27.703125 35.855469 27.417969 36.0625 27.113281 C 36.265625 26.808594 36.4375 26.484375 36.578125 26.144531 C 36.71875 25.804688 36.824219 25.457031 36.898438 25.09375 C 36.96875 24.734375 37.007812 24.371094 37.007812 24.003906 L 37.007812 5.925781 Z M 19.15625 17.082031 "></path></g></g></svg>
                                </span>
                                <span class="d-block position-relative text-white" style="top: -3px;">
                                    saobernardo@saobernardo.ind.br
                                </span>
                            </a>
                        </li>
                        <li>
                            <a href="callto:+551126739052" class="link link--text list-menu__item list-menu__item--link p-0 m-0 d-flex align-items-center mb-1">
                                <span class="d-block">
                                <svg style="transform: rotate(10deg);" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" zoomAndPan="magnify" viewBox="0 0 31.92 37.500001" height="23" preserveAspectRatio="xMidYMid meet" version="1.2"><defs><clipPath id="67aa1018ab"><path d="M 0.171875 0.148438 L 31.257812 0.148438 L 31.257812 29.605469 L 0.171875 29.605469 Z M 0.171875 0.148438 "></path></clipPath></defs><g id="deb4d62498"><g clip-rule="nonzero" clip-path="url(#67aa1018ab)"><path style=" stroke:none;fill-rule:nonzero;fill:#ffffff;fill-opacity:1;" d="M 5.085938 0.625 C 4.222656 0.582031 3.453125 0.832031 2.78125 1.378906 C 1.929688 2.175781 1.28125 3.109375 0.832031 4.1875 C 0.386719 5.261719 0.179688 6.382812 0.214844 7.546875 C 0.324219 8.96875 0.636719 10.335938 1.160156 11.660156 C 1.683594 12.980469 2.390625 14.195312 3.285156 15.304688 L 3.472656 15.589844 C 5.078125 18.089844 6.996094 20.324219 9.226562 22.285156 C 11.460938 24.246094 13.921875 25.859375 16.609375 27.128906 C 19.046875 28.3125 21.617188 29.039062 24.316406 29.308594 C 24.800781 29.304688 25.28125 29.242188 25.75 29.121094 C 27.648438 28.726562 30.027344 27.308594 30.578125 25.730469 C 31.011719 24.683594 31.183594 23.601562 31.09375 22.472656 C 30.855469 22.335938 30.609375 22.210938 30.355469 22.097656 L 29.890625 21.859375 C 27.726562 20.824219 25.066406 19.515625 24.539062 19.308594 C 24.382812 19.261719 24.226562 19.238281 24.066406 19.234375 C 23.746094 19.230469 23.511719 19.367188 23.359375 19.648438 L 23.050781 20.09375 C 22.46875 20.945312 21.839844 21.761719 21.167969 22.546875 C 20.8125 22.894531 20.386719 23.113281 19.898438 23.203125 C 19.410156 23.292969 18.9375 23.242188 18.480469 23.046875 L 18.242188 22.9375 C 15.882812 21.988281 13.765625 20.65625 11.886719 18.945312 C 10.082031 17.28125 8.554688 15.390625 7.3125 13.277344 C 7.191406 13.082031 7.105469 12.871094 7.0625 12.648438 C 7.015625 12.421875 7.011719 12.195312 7.042969 11.96875 C 7.078125 11.742188 7.152344 11.53125 7.261719 11.328125 C 7.375 11.128906 7.515625 10.953125 7.6875 10.800781 C 7.914062 10.511719 8.164062 10.242188 8.433594 9.992188 C 8.574219 9.804688 8.746094 9.65625 8.890625 9.476562 C 9.210938 9.152344 9.476562 8.785156 9.6875 8.378906 C 9.773438 8.070312 9.734375 7.78125 9.5625 7.511719 C 9.40625 7.230469 8.773438 5.628906 7.835938 3.402344 L 7.101562 1.574219 C 6.722656 0.65625 6.609375 0.644531 5.960938 0.644531 L 5.738281 0.644531 C 5.546875 0.636719 5.308594 0.625 5.085938 0.625 Z M 5.085938 0.625 "></path></g></g></svg>
                                </span>
                                <span class="fs-3 d-block position-relative text-white" style="top: -3px;">
                                Escritório: (11) 2673-9052
                                </span>
                            </a>
                        </li>
                        <li>
                            <a href="callto:+551146462929" class="link link--text list-menu__item list-menu__item--link p-0 m-0 d-flex align-items-center">
                                <span class="d-block" style="opacity: 0;">
                                <svg style="transform: rotate(10deg);" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" zoomAndPan="magnify" viewBox="0 0 31.92 37.500001" height="23" preserveAspectRatio="xMidYMid meet" version="1.2"><defs><clipPath id="67aa1018ab"><path d="M 0.171875 0.148438 L 31.257812 0.148438 L 31.257812 29.605469 L 0.171875 29.605469 Z M 0.171875 0.148438 "></path></clipPath></defs><g id="deb4d62498"><g clip-rule="nonzero" clip-path="url(#67aa1018ab)"><path style=" stroke:none;fill-rule:nonzero;fill:#ffffff;fill-opacity:1;" d="M 5.085938 0.625 C 4.222656 0.582031 3.453125 0.832031 2.78125 1.378906 C 1.929688 2.175781 1.28125 3.109375 0.832031 4.1875 C 0.386719 5.261719 0.179688 6.382812 0.214844 7.546875 C 0.324219 8.96875 0.636719 10.335938 1.160156 11.660156 C 1.683594 12.980469 2.390625 14.195312 3.285156 15.304688 L 3.472656 15.589844 C 5.078125 18.089844 6.996094 20.324219 9.226562 22.285156 C 11.460938 24.246094 13.921875 25.859375 16.609375 27.128906 C 19.046875 28.3125 21.617188 29.039062 24.316406 29.308594 C 24.800781 29.304688 25.28125 29.242188 25.75 29.121094 C 27.648438 28.726562 30.027344 27.308594 30.578125 25.730469 C 31.011719 24.683594 31.183594 23.601562 31.09375 22.472656 C 30.855469 22.335938 30.609375 22.210938 30.355469 22.097656 L 29.890625 21.859375 C 27.726562 20.824219 25.066406 19.515625 24.539062 19.308594 C 24.382812 19.261719 24.226562 19.238281 24.066406 19.234375 C 23.746094 19.230469 23.511719 19.367188 23.359375 19.648438 L 23.050781 20.09375 C 22.46875 20.945312 21.839844 21.761719 21.167969 22.546875 C 20.8125 22.894531 20.386719 23.113281 19.898438 23.203125 C 19.410156 23.292969 18.9375 23.242188 18.480469 23.046875 L 18.242188 22.9375 C 15.882812 21.988281 13.765625 20.65625 11.886719 18.945312 C 10.082031 17.28125 8.554688 15.390625 7.3125 13.277344 C 7.191406 13.082031 7.105469 12.871094 7.0625 12.648438 C 7.015625 12.421875 7.011719 12.195312 7.042969 11.96875 C 7.078125 11.742188 7.152344 11.53125 7.261719 11.328125 C 7.375 11.128906 7.515625 10.953125 7.6875 10.800781 C 7.914062 10.511719 8.164062 10.242188 8.433594 9.992188 C 8.574219 9.804688 8.746094 9.65625 8.890625 9.476562 C 9.210938 9.152344 9.476562 8.785156 9.6875 8.378906 C 9.773438 8.070312 9.734375 7.78125 9.5625 7.511719 C 9.40625 7.230469 8.773438 5.628906 7.835938 3.402344 L 7.101562 1.574219 C 6.722656 0.65625 6.609375 0.644531 5.960938 0.644531 L 5.738281 0.644531 C 5.546875 0.636719 5.308594 0.625 5.085938 0.625 Z M 5.085938 0.625 "></path></g></g></svg>
                                </span>
                                <span class="fs-3 d-block position-relative text-white" style="top: -3px;">
                                Fábrica: (11) 4646-2929
                                </span>
                            </a>                            
                        </li>
                          <li class="mb-5">
                                <a href="https://api.whatsapp.com/send?phone=5511932160215" class="link link--text list-menu__item list-menu__item--link p-0 m-0 d-flex align-items-center">
                                    <span class="d-block" style="opacity: 0;">
                                    <svg style="transform: rotate(10deg);" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" zoomAndPan="magnify" viewBox="0 0 31.92 37.500001" height="23" preserveAspectRatio="xMidYMid meet" version="1.2"><defs><clipPath id="67aa1018ab"><path d="M 0.171875 0.148438 L 31.257812 0.148438 L 31.257812 29.605469 L 0.171875 29.605469 Z M 0.171875 0.148438 "></path></clipPath></defs><g id="deb4d62498"><g clip-rule="nonzero" clip-path="url(#67aa1018ab)"><path style=" stroke:none;fill-rule:nonzero;fill:#ffffff;fill-opacity:1;" d="M 5.085938 0.625 C 4.222656 0.582031 3.453125 0.832031 2.78125 1.378906 C 1.929688 2.175781 1.28125 3.109375 0.832031 4.1875 C 0.386719 5.261719 0.179688 6.382812 0.214844 7.546875 C 0.324219 8.96875 0.636719 10.335938 1.160156 11.660156 C 1.683594 12.980469 2.390625 14.195312 3.285156 15.304688 L 3.472656 15.589844 C 5.078125 18.089844 6.996094 20.324219 9.226562 22.285156 C 11.460938 24.246094 13.921875 25.859375 16.609375 27.128906 C 19.046875 28.3125 21.617188 29.039062 24.316406 29.308594 C 24.800781 29.304688 25.28125 29.242188 25.75 29.121094 C 27.648438 28.726562 30.027344 27.308594 30.578125 25.730469 C 31.011719 24.683594 31.183594 23.601562 31.09375 22.472656 C 30.855469 22.335938 30.609375 22.210938 30.355469 22.097656 L 29.890625 21.859375 C 27.726562 20.824219 25.066406 19.515625 24.539062 19.308594 C 24.382812 19.261719 24.226562 19.238281 24.066406 19.234375 C 23.746094 19.230469 23.511719 19.367188 23.359375 19.648438 L 23.050781 20.09375 C 22.46875 20.945312 21.839844 21.761719 21.167969 22.546875 C 20.8125 22.894531 20.386719 23.113281 19.898438 23.203125 C 19.410156 23.292969 18.9375 23.242188 18.480469 23.046875 L 18.242188 22.9375 C 15.882812 21.988281 13.765625 20.65625 11.886719 18.945312 C 10.082031 17.28125 8.554688 15.390625 7.3125 13.277344 C 7.191406 13.082031 7.105469 12.871094 7.0625 12.648438 C 7.015625 12.421875 7.011719 12.195312 7.042969 11.96875 C 7.078125 11.742188 7.152344 11.53125 7.261719 11.328125 C 7.375 11.128906 7.515625 10.953125 7.6875 10.800781 C 7.914062 10.511719 8.164062 10.242188 8.433594 9.992188 C 8.574219 9.804688 8.746094 9.65625 8.890625 9.476562 C 9.210938 9.152344 9.476562 8.785156 9.6875 8.378906 C 9.773438 8.070312 9.734375 7.78125 9.5625 7.511719 C 9.40625 7.230469 8.773438 5.628906 7.835938 3.402344 L 7.101562 1.574219 C 6.722656 0.65625 6.609375 0.644531 5.960938 0.644531 L 5.738281 0.644531 C 5.546875 0.636719 5.308594 0.625 5.085938 0.625 Z M 5.085938 0.625 "></path></g></g></svg>
                                    </span>
                                    <span class="fs-3 d-block position-relative text-white" style="top: -3px;">
                                    WhatsApp: (11) 9 3216-0215
                                    </span>
                                </a>                            
                          </li>                      
                    </ul>
    `
}


/*--------------------------------------------------------------------------------
# FOOTER JS GLOBAL ||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||
--------------------------------------------------------------------------------*/

const footerColumnInfo = document.querySelector('.footer__column--info')

if(footerColumnInfo){
   footerColumnInfo.closest('.footer__content-bottom').classList.add('p-0')
   footerColumnInfo.style.cssText = `
   flex-direction: row;
   justify-content: space-around;
   row-gap: 1.25em;
   flex-wrap: wrap;
   `
    footerColumnInfo.innerHTML = `
          <div class="col-12 col-md-6 col-xl-5 d-none align-items-start content-address">
                                      <span><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" zoomAndPan="magnify" viewBox="0 0 375 374.999991" height="25" preserveAspectRatio="xMidYMid meet" version="1.0">
                                              <defs>
                                                  <clipPath id="d3f652a8e7">
                                                      <path d="M 42.890625 0 L 332.390625 0 L 332.390625 375 L 42.890625 375 Z M 42.890625 0 " clip-rule="nonzero"></path>
                                                  </clipPath>
                                              </defs>
                                              <g clip-path="url(#d3f652a8e7)">
                                                  <path fill="#ffffff" d="M 187.640625 0.105469 C 185.273438 0.105469 182.902344 0.160156 180.539062 0.277344 C 178.171875 0.394531 175.808594 0.566406 173.453125 0.800781 C 171.09375 1.03125 168.746094 1.320312 166.402344 1.667969 C 164.058594 2.015625 161.726562 2.421875 159.402344 2.882812 C 157.078125 3.34375 154.765625 3.863281 152.46875 4.4375 C 150.171875 5.011719 147.890625 5.644531 145.621094 6.332031 C 143.355469 7.015625 141.105469 7.757812 138.875 8.558594 C 136.644531 9.355469 134.4375 10.207031 132.246094 11.109375 C 130.058594 12.015625 127.894531 12.976562 125.753906 13.988281 C 123.609375 15 121.496094 16.0625 119.40625 17.179688 C 117.316406 18.292969 115.257812 19.460938 113.222656 20.675781 C 111.191406 21.894531 109.191406 23.160156 107.222656 24.476562 C 105.253906 25.789062 103.316406 27.152344 101.414062 28.5625 C 99.511719 29.972656 97.644531 31.425781 95.8125 32.929688 C 93.980469 34.429688 92.1875 35.976562 90.433594 37.566406 C 88.675781 39.152344 86.960938 40.785156 85.285156 42.457031 C 83.613281 44.132812 81.980469 45.84375 80.386719 47.597656 C 78.796875 49.351562 77.25 51.144531 75.746094 52.972656 C 74.246094 54.804688 72.789062 56.667969 71.375 58.570312 C 69.964844 60.46875 68.601562 62.40625 67.285156 64.371094 C 65.96875 66.339844 64.703125 68.339844 63.484375 70.367188 C 62.265625 72.398438 61.097656 74.457031 59.984375 76.542969 C 58.867188 78.632812 57.800781 80.746094 56.789062 82.882812 C 55.773438 85.023438 54.816406 87.1875 53.910156 89.375 C 53.003906 91.558594 52.148438 93.765625 51.351562 95.996094 C 50.554688 98.222656 49.8125 100.46875 49.125 102.734375 C 48.4375 105 47.804688 107.28125 47.230469 109.574219 C 46.652344 111.871094 46.132812 114.179688 45.671875 116.5 C 45.210938 118.820312 44.804688 121.152344 44.457031 123.496094 C 44.109375 125.835938 43.820312 128.183594 43.585938 130.539062 C 43.355469 132.894531 43.179688 135.253906 43.066406 137.617188 C 42.949219 139.980469 42.890625 142.347656 42.890625 144.714844 C 42.890625 212.847656 148.171875 335.902344 179.183594 370.886719 C 179.449219 371.1875 179.730469 371.472656 180.027344 371.742188 C 180.324219 372.011719 180.632812 372.265625 180.957031 372.503906 C 181.28125 372.738281 181.613281 372.960938 181.960938 373.160156 C 182.308594 373.363281 182.664062 373.546875 183.03125 373.710938 C 183.394531 373.875 183.769531 374.019531 184.148438 374.144531 C 184.53125 374.269531 184.917969 374.371094 185.308594 374.457031 C 185.699219 374.539062 186.097656 374.601562 186.496094 374.644531 C 186.894531 374.6875 187.292969 374.707031 187.695312 374.707031 C 188.097656 374.707031 188.496094 374.6875 188.894531 374.644531 C 189.292969 374.601562 189.6875 374.539062 190.082031 374.457031 C 190.472656 374.371094 190.859375 374.269531 191.238281 374.144531 C 191.621094 374.019531 191.996094 373.875 192.359375 373.710938 C 192.726562 373.546875 193.082031 373.363281 193.429688 373.160156 C 193.773438 372.960938 194.109375 372.738281 194.433594 372.503906 C 194.757812 372.265625 195.066406 372.011719 195.363281 371.742188 C 195.660156 371.472656 195.941406 371.1875 196.207031 370.886719 C 227.214844 335.902344 332.390625 212.847656 332.390625 144.714844 C 332.390625 142.347656 332.332031 139.980469 332.214844 137.617188 C 332.101562 135.253906 331.925781 132.894531 331.695312 130.539062 C 331.460938 128.183594 331.171875 125.835938 330.824219 123.496094 C 330.476562 121.152344 330.070312 118.820312 329.609375 116.5 C 329.148438 114.179688 328.628906 111.871094 328.050781 109.574219 C 327.476562 107.28125 326.84375 105 326.15625 102.734375 C 325.46875 100.46875 324.726562 98.222656 323.929688 95.996094 C 323.132812 93.765625 322.277344 91.558594 321.371094 89.375 C 320.464844 87.1875 319.507812 85.023438 318.492188 82.882812 C 317.480469 80.746094 316.414062 78.632812 315.296875 76.542969 C 314.183594 74.457031 313.015625 72.398438 311.796875 70.367188 C 310.578125 68.339844 309.3125 66.339844 307.996094 64.371094 C 306.679688 62.40625 305.316406 60.46875 303.90625 58.570312 C 302.492188 56.667969 301.035156 54.804688 299.535156 52.972656 C 298.03125 51.144531 296.484375 49.351562 294.894531 47.597656 C 293.300781 45.84375 291.667969 44.132812 289.996094 42.457031 C 288.320312 40.785156 286.605469 39.152344 284.847656 37.566406 C 283.09375 35.976562 281.300781 34.429688 279.46875 32.929688 C 277.636719 31.425781 275.769531 29.972656 273.867188 28.5625 C 271.964844 27.152344 270.027344 25.789062 268.058594 24.476562 C 266.089844 23.160156 264.089844 21.894531 262.058594 20.675781 C 260.023438 19.460938 257.964844 18.292969 255.875 17.179688 C 253.785156 16.0625 251.671875 15 249.527344 13.988281 C 247.386719 12.976562 245.222656 12.015625 243.035156 11.109375 C 240.84375 10.207031 238.636719 9.355469 236.40625 8.558594 C 234.175781 7.757812 231.925781 7.015625 229.660156 6.332031 C 227.390625 5.644531 225.109375 5.011719 222.8125 4.4375 C 220.515625 3.863281 218.203125 3.34375 215.878906 2.882812 C 213.554688 2.421875 211.222656 2.015625 208.878906 1.667969 C 206.535156 1.320312 204.1875 1.03125 201.828125 0.800781 C 199.472656 0.566406 197.109375 0.394531 194.742188 0.277344 C 192.378906 0.160156 190.007812 0.105469 187.640625 0.105469 Z M 187.640625 209.273438 C 186.46875 209.273438 185.300781 209.242188 184.128906 209.1875 C 182.960938 209.128906 181.792969 209.042969 180.625 208.929688 C 179.460938 208.8125 178.296875 208.671875 177.140625 208.5 C 175.980469 208.328125 174.828125 208.128906 173.679688 207.898438 C 172.53125 207.671875 171.386719 207.414062 170.253906 207.128906 C 169.117188 206.847656 167.988281 206.535156 166.867188 206.195312 C 165.746094 205.855469 164.636719 205.488281 163.53125 205.09375 C 162.429688 204.699219 161.335938 204.277344 160.253906 203.832031 C 159.171875 203.382812 158.101562 202.910156 157.042969 202.410156 C 155.984375 201.910156 154.941406 201.382812 153.90625 200.832031 C 152.875 200.28125 151.855469 199.703125 150.851562 199.101562 C 149.847656 198.5 148.855469 197.875 147.882812 197.222656 C 146.910156 196.574219 145.953125 195.902344 145.011719 195.203125 C 144.070312 194.507812 143.148438 193.785156 142.242188 193.042969 C 141.335938 192.300781 140.449219 191.539062 139.582031 190.753906 C 138.714844 189.96875 137.867188 189.160156 137.039062 188.332031 C 136.210938 187.503906 135.402344 186.660156 134.617188 185.792969 C 133.832031 184.925781 133.066406 184.039062 132.324219 183.132812 C 131.578125 182.230469 130.859375 181.308594 130.160156 180.367188 C 129.464844 179.429688 128.789062 178.472656 128.140625 177.5 C 127.488281 176.527344 126.863281 175.539062 126.261719 174.535156 C 125.65625 173.53125 125.082031 172.511719 124.527344 171.480469 C 123.976562 170.449219 123.449219 169.40625 122.949219 168.347656 C 122.449219 167.289062 121.972656 166.21875 121.527344 165.140625 C 121.078125 164.058594 120.65625 162.96875 120.261719 161.867188 C 119.867188 160.765625 119.5 159.652344 119.160156 158.535156 C 118.820312 157.414062 118.507812 156.285156 118.222656 155.152344 C 117.9375 154.015625 117.683594 152.875 117.453125 151.726562 C 117.226562 150.582031 117.023438 149.429688 116.851562 148.269531 C 116.679688 147.113281 116.539062 145.953125 116.421875 144.789062 C 116.308594 143.625 116.222656 142.457031 116.164062 141.289062 C 116.109375 140.121094 116.078125 138.949219 116.078125 137.78125 C 116.078125 136.609375 116.109375 135.441406 116.164062 134.273438 C 116.222656 133.105469 116.308594 131.9375 116.421875 130.773438 C 116.539062 129.609375 116.679688 128.449219 116.851562 127.289062 C 117.023438 126.132812 117.226562 124.980469 117.453125 123.832031 C 117.683594 122.683594 117.9375 121.542969 118.222656 120.410156 C 118.507812 119.273438 118.820312 118.148438 119.160156 117.027344 C 119.5 115.90625 119.867188 114.796875 120.261719 113.695312 C 120.65625 112.59375 121.078125 111.503906 121.527344 110.421875 C 121.972656 109.339844 122.449219 108.269531 122.949219 107.214844 C 123.449219 106.15625 123.976562 105.109375 124.527344 104.078125 C 125.082031 103.046875 125.65625 102.03125 126.261719 101.027344 C 126.863281 100.023438 127.488281 99.035156 128.140625 98.0625 C 128.789062 97.089844 129.464844 96.132812 130.160156 95.191406 C 130.859375 94.253906 131.578125 93.332031 132.324219 92.425781 C 133.066406 91.523438 133.832031 90.636719 134.617188 89.769531 C 135.402344 88.902344 136.210938 88.054688 137.039062 87.226562 C 137.867188 86.398438 138.714844 85.59375 139.582031 84.808594 C 140.449219 84.023438 141.335938 83.257812 142.242188 82.515625 C 143.148438 81.773438 144.070312 81.054688 145.011719 80.355469 C 145.953125 79.660156 146.910156 78.988281 147.882812 78.335938 C 148.855469 77.6875 149.847656 77.0625 150.851562 76.460938 C 151.855469 75.859375 152.875 75.28125 153.90625 74.730469 C 154.941406 74.179688 155.984375 73.652344 157.042969 73.152344 C 158.101562 72.652344 159.171875 72.179688 160.253906 71.730469 C 161.335938 71.28125 162.429688 70.863281 163.53125 70.46875 C 164.636719 70.074219 165.746094 69.707031 166.867188 69.367188 C 167.988281 69.027344 169.117188 68.714844 170.253906 68.429688 C 171.386719 68.144531 172.53125 67.890625 173.679688 67.660156 C 174.828125 67.433594 175.980469 67.234375 177.140625 67.0625 C 178.296875 66.890625 179.460938 66.746094 180.625 66.632812 C 181.792969 66.519531 182.960938 66.429688 184.128906 66.375 C 185.300781 66.316406 186.46875 66.289062 187.640625 66.289062 C 188.8125 66.289062 189.980469 66.316406 191.152344 66.375 C 192.320312 66.429688 193.488281 66.519531 194.65625 66.632812 C 195.820312 66.746094 196.984375 66.890625 198.140625 67.0625 C 199.300781 67.234375 200.453125 67.433594 201.601562 67.660156 C 202.75 67.890625 203.894531 68.144531 205.027344 68.429688 C 206.164062 68.714844 207.292969 69.027344 208.414062 69.367188 C 209.535156 69.707031 210.644531 70.074219 211.75 70.46875 C 212.851562 70.863281 213.945312 71.28125 215.027344 71.730469 C 216.109375 72.179688 217.179688 72.652344 218.238281 73.152344 C 219.296875 73.652344 220.339844 74.179688 221.375 74.730469 C 222.40625 75.28125 223.425781 75.859375 224.429688 76.460938 C 225.433594 77.0625 226.425781 77.6875 227.398438 78.335938 C 228.371094 78.988281 229.328125 79.660156 230.269531 80.355469 C 231.210938 81.054688 232.132812 81.773438 233.039062 82.515625 C 233.945312 83.257812 234.832031 84.023438 235.699219 84.808594 C 236.566406 85.59375 237.414062 86.398438 238.242188 87.226562 C 239.070312 88.054688 239.878906 88.902344 240.664062 89.769531 C 241.449219 90.636719 242.214844 91.523438 242.957031 92.425781 C 243.703125 93.332031 244.421875 94.253906 245.121094 95.191406 C 245.816406 96.132812 246.492188 97.089844 247.140625 98.0625 C 247.792969 99.035156 248.417969 100.023438 249.019531 101.027344 C 249.625 102.03125 250.199219 103.046875 250.753906 104.078125 C 251.304688 105.109375 251.832031 106.15625 252.332031 107.214844 C 252.832031 108.269531 253.308594 109.339844 253.753906 110.421875 C 254.203125 111.503906 254.625 112.59375 255.019531 113.695312 C 255.414062 114.796875 255.78125 115.90625 256.121094 117.027344 C 256.460938 118.148438 256.773438 119.273438 257.058594 120.410156 C 257.34375 121.542969 257.597656 122.683594 257.828125 123.832031 C 258.054688 124.980469 258.257812 126.132812 258.429688 127.289062 C 258.601562 128.449219 258.742188 129.609375 258.859375 130.773438 C 258.972656 131.9375 259.058594 133.105469 259.117188 134.273438 C 259.171875 135.441406 259.203125 136.609375 259.203125 137.78125 C 259.199219 138.949219 259.171875 140.117188 259.109375 141.285156 C 259.050781 142.453125 258.964844 143.621094 258.847656 144.785156 C 258.730469 145.949219 258.585938 147.109375 258.414062 148.265625 C 258.242188 149.421875 258.039062 150.574219 257.808594 151.71875 C 257.578125 152.867188 257.320312 154.007812 257.035156 155.140625 C 256.75 156.277344 256.4375 157.402344 256.097656 158.519531 C 255.753906 159.640625 255.386719 160.75 254.992188 161.851562 C 254.597656 162.953125 254.175781 164.042969 253.726562 165.121094 C 253.277344 166.203125 252.800781 167.269531 252.300781 168.328125 C 251.800781 169.386719 251.273438 170.429688 250.71875 171.460938 C 250.167969 172.492188 249.589844 173.507812 248.988281 174.511719 C 248.386719 175.515625 247.757812 176.5 247.109375 177.472656 C 246.457031 178.445312 245.785156 179.402344 245.085938 180.339844 C 244.386719 181.28125 243.667969 182.203125 242.925781 183.105469 C 242.183594 184.007812 241.417969 184.894531 240.632812 185.761719 C 239.84375 186.628906 239.039062 187.472656 238.210938 188.300781 C 237.382812 189.128906 236.535156 189.933594 235.667969 190.71875 C 234.800781 191.503906 233.914062 192.269531 233.011719 193.011719 C 232.105469 193.753906 231.183594 194.472656 230.242188 195.171875 C 229.300781 195.867188 228.347656 196.539062 227.371094 197.191406 C 226.398438 197.839844 225.410156 198.46875 224.40625 199.070312 C 223.402344 199.671875 222.386719 200.246094 221.351562 200.800781 C 220.320312 201.351562 219.277344 201.878906 218.21875 202.378906 C 217.160156 202.878906 216.089844 203.351562 215.007812 203.800781 C 213.929688 204.25 212.835938 204.671875 211.734375 205.066406 C 210.632812 205.460938 209.523438 205.828125 208.402344 206.171875 C 207.28125 206.511719 206.152344 206.824219 205.019531 207.109375 C 203.882812 207.394531 202.742188 207.652344 201.59375 207.882812 C 200.445312 208.109375 199.292969 208.3125 198.136719 208.484375 C 196.976562 208.65625 195.816406 208.800781 194.652344 208.917969 C 193.488281 209.035156 192.320312 209.121094 191.152344 209.179688 C 189.980469 209.242188 188.8125 209.269531 187.640625 209.273438 Z M 187.640625 209.273438 " fill-opacity="1" fill-rule="nonzero"></path>
                                              </g>
                                          </svg></span>
                                      <span class="fs-4" style="
                                          position: relative;
                                          top: -5px;
                                          padding-left: 10px;
                                          display: block;
                                          line-height: 1.2;
                                      ">
                                          <strong data-translate-key="office">ESCRITÓRIO</strong><br>
                                          Rua Azevedo Soares, 253 <br>
                                          Tatuapé - SP - CEP: 03309-000
                                      </span>
                                  </div>
                                  
                                  <div class="col-12 d-flex align-items-start content-address justify-content-center">
                                      <span><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" zoomAndPan="magnify" viewBox="0 0 375 374.999991" height="25" preserveAspectRatio="xMidYMid meet" version="1.0">
                                              <defs>
                                                  <clipPath id="d3f652a8e7">
                                                      <path d="M 42.890625 0 L 332.390625 0 L 332.390625 375 L 42.890625 375 Z M 42.890625 0 " clip-rule="nonzero"></path>
                                                  </clipPath>
                                              </defs>
                                              <g clip-path="url(#d3f652a8e7)">
                                                  <path fill="#ffffff" d="M 187.640625 0.105469 C 185.273438 0.105469 182.902344 0.160156 180.539062 0.277344 C 178.171875 0.394531 175.808594 0.566406 173.453125 0.800781 C 171.09375 1.03125 168.746094 1.320312 166.402344 1.667969 C 164.058594 2.015625 161.726562 2.421875 159.402344 2.882812 C 157.078125 3.34375 154.765625 3.863281 152.46875 4.4375 C 150.171875 5.011719 147.890625 5.644531 145.621094 6.332031 C 143.355469 7.015625 141.105469 7.757812 138.875 8.558594 C 136.644531 9.355469 134.4375 10.207031 132.246094 11.109375 C 130.058594 12.015625 127.894531 12.976562 125.753906 13.988281 C 123.609375 15 121.496094 16.0625 119.40625 17.179688 C 117.316406 18.292969 115.257812 19.460938 113.222656 20.675781 C 111.191406 21.894531 109.191406 23.160156 107.222656 24.476562 C 105.253906 25.789062 103.316406 27.152344 101.414062 28.5625 C 99.511719 29.972656 97.644531 31.425781 95.8125 32.929688 C 93.980469 34.429688 92.1875 35.976562 90.433594 37.566406 C 88.675781 39.152344 86.960938 40.785156 85.285156 42.457031 C 83.613281 44.132812 81.980469 45.84375 80.386719 47.597656 C 78.796875 49.351562 77.25 51.144531 75.746094 52.972656 C 74.246094 54.804688 72.789062 56.667969 71.375 58.570312 C 69.964844 60.46875 68.601562 62.40625 67.285156 64.371094 C 65.96875 66.339844 64.703125 68.339844 63.484375 70.367188 C 62.265625 72.398438 61.097656 74.457031 59.984375 76.542969 C 58.867188 78.632812 57.800781 80.746094 56.789062 82.882812 C 55.773438 85.023438 54.816406 87.1875 53.910156 89.375 C 53.003906 91.558594 52.148438 93.765625 51.351562 95.996094 C 50.554688 98.222656 49.8125 100.46875 49.125 102.734375 C 48.4375 105 47.804688 107.28125 47.230469 109.574219 C 46.652344 111.871094 46.132812 114.179688 45.671875 116.5 C 45.210938 118.820312 44.804688 121.152344 44.457031 123.496094 C 44.109375 125.835938 43.820312 128.183594 43.585938 130.539062 C 43.355469 132.894531 43.179688 135.253906 43.066406 137.617188 C 42.949219 139.980469 42.890625 142.347656 42.890625 144.714844 C 42.890625 212.847656 148.171875 335.902344 179.183594 370.886719 C 179.449219 371.1875 179.730469 371.472656 180.027344 371.742188 C 180.324219 372.011719 180.632812 372.265625 180.957031 372.503906 C 181.28125 372.738281 181.613281 372.960938 181.960938 373.160156 C 182.308594 373.363281 182.664062 373.546875 183.03125 373.710938 C 183.394531 373.875 183.769531 374.019531 184.148438 374.144531 C 184.53125 374.269531 184.917969 374.371094 185.308594 374.457031 C 185.699219 374.539062 186.097656 374.601562 186.496094 374.644531 C 186.894531 374.6875 187.292969 374.707031 187.695312 374.707031 C 188.097656 374.707031 188.496094 374.6875 188.894531 374.644531 C 189.292969 374.601562 189.6875 374.539062 190.082031 374.457031 C 190.472656 374.371094 190.859375 374.269531 191.238281 374.144531 C 191.621094 374.019531 191.996094 373.875 192.359375 373.710938 C 192.726562 373.546875 193.082031 373.363281 193.429688 373.160156 C 193.773438 372.960938 194.109375 372.738281 194.433594 372.503906 C 194.757812 372.265625 195.066406 372.011719 195.363281 371.742188 C 195.660156 371.472656 195.941406 371.1875 196.207031 370.886719 C 227.214844 335.902344 332.390625 212.847656 332.390625 144.714844 C 332.390625 142.347656 332.332031 139.980469 332.214844 137.617188 C 332.101562 135.253906 331.925781 132.894531 331.695312 130.539062 C 331.460938 128.183594 331.171875 125.835938 330.824219 123.496094 C 330.476562 121.152344 330.070312 118.820312 329.609375 116.5 C 329.148438 114.179688 328.628906 111.871094 328.050781 109.574219 C 327.476562 107.28125 326.84375 105 326.15625 102.734375 C 325.46875 100.46875 324.726562 98.222656 323.929688 95.996094 C 323.132812 93.765625 322.277344 91.558594 321.371094 89.375 C 320.464844 87.1875 319.507812 85.023438 318.492188 82.882812 C 317.480469 80.746094 316.414062 78.632812 315.296875 76.542969 C 314.183594 74.457031 313.015625 72.398438 311.796875 70.367188 C 310.578125 68.339844 309.3125 66.339844 307.996094 64.371094 C 306.679688 62.40625 305.316406 60.46875 303.90625 58.570312 C 302.492188 56.667969 301.035156 54.804688 299.535156 52.972656 C 298.03125 51.144531 296.484375 49.351562 294.894531 47.597656 C 293.300781 45.84375 291.667969 44.132812 289.996094 42.457031 C 288.320312 40.785156 286.605469 39.152344 284.847656 37.566406 C 283.09375 35.976562 281.300781 34.429688 279.46875 32.929688 C 277.636719 31.425781 275.769531 29.972656 273.867188 28.5625 C 271.964844 27.152344 270.027344 25.789062 268.058594 24.476562 C 266.089844 23.160156 264.089844 21.894531 262.058594 20.675781 C 260.023438 19.460938 257.964844 18.292969 255.875 17.179688 C 253.785156 16.0625 251.671875 15 249.527344 13.988281 C 247.386719 12.976562 245.222656 12.015625 243.035156 11.109375 C 240.84375 10.207031 238.636719 9.355469 236.40625 8.558594 C 234.175781 7.757812 231.925781 7.015625 229.660156 6.332031 C 227.390625 5.644531 225.109375 5.011719 222.8125 4.4375 C 220.515625 3.863281 218.203125 3.34375 215.878906 2.882812 C 213.554688 2.421875 211.222656 2.015625 208.878906 1.667969 C 206.535156 1.320312 204.1875 1.03125 201.828125 0.800781 C 199.472656 0.566406 197.109375 0.394531 194.742188 0.277344 C 192.378906 0.160156 190.007812 0.105469 187.640625 0.105469 Z M 187.640625 209.273438 C 186.46875 209.273438 185.300781 209.242188 184.128906 209.1875 C 182.960938 209.128906 181.792969 209.042969 180.625 208.929688 C 179.460938 208.8125 178.296875 208.671875 177.140625 208.5 C 175.980469 208.328125 174.828125 208.128906 173.679688 207.898438 C 172.53125 207.671875 171.386719 207.414062 170.253906 207.128906 C 169.117188 206.847656 167.988281 206.535156 166.867188 206.195312 C 165.746094 205.855469 164.636719 205.488281 163.53125 205.09375 C 162.429688 204.699219 161.335938 204.277344 160.253906 203.832031 C 159.171875 203.382812 158.101562 202.910156 157.042969 202.410156 C 155.984375 201.910156 154.941406 201.382812 153.90625 200.832031 C 152.875 200.28125 151.855469 199.703125 150.851562 199.101562 C 149.847656 198.5 148.855469 197.875 147.882812 197.222656 C 146.910156 196.574219 145.953125 195.902344 145.011719 195.203125 C 144.070312 194.507812 143.148438 193.785156 142.242188 193.042969 C 141.335938 192.300781 140.449219 191.539062 139.582031 190.753906 C 138.714844 189.96875 137.867188 189.160156 137.039062 188.332031 C 136.210938 187.503906 135.402344 186.660156 134.617188 185.792969 C 133.832031 184.925781 133.066406 184.039062 132.324219 183.132812 C 131.578125 182.230469 130.859375 181.308594 130.160156 180.367188 C 129.464844 179.429688 128.789062 178.472656 128.140625 177.5 C 127.488281 176.527344 126.863281 175.539062 126.261719 174.535156 C 125.65625 173.53125 125.082031 172.511719 124.527344 171.480469 C 123.976562 170.449219 123.449219 169.40625 122.949219 168.347656 C 122.449219 167.289062 121.972656 166.21875 121.527344 165.140625 C 121.078125 164.058594 120.65625 162.96875 120.261719 161.867188 C 119.867188 160.765625 119.5 159.652344 119.160156 158.535156 C 118.820312 157.414062 118.507812 156.285156 118.222656 155.152344 C 117.9375 154.015625 117.683594 152.875 117.453125 151.726562 C 117.226562 150.582031 117.023438 149.429688 116.851562 148.269531 C 116.679688 147.113281 116.539062 145.953125 116.421875 144.789062 C 116.308594 143.625 116.222656 142.457031 116.164062 141.289062 C 116.109375 140.121094 116.078125 138.949219 116.078125 137.78125 C 116.078125 136.609375 116.109375 135.441406 116.164062 134.273438 C 116.222656 133.105469 116.308594 131.9375 116.421875 130.773438 C 116.539062 129.609375 116.679688 128.449219 116.851562 127.289062 C 117.023438 126.132812 117.226562 124.980469 117.453125 123.832031 C 117.683594 122.683594 117.9375 121.542969 118.222656 120.410156 C 118.507812 119.273438 118.820312 118.148438 119.160156 117.027344 C 119.5 115.90625 119.867188 114.796875 120.261719 113.695312 C 120.65625 112.59375 121.078125 111.503906 121.527344 110.421875 C 121.972656 109.339844 122.449219 108.269531 122.949219 107.214844 C 123.449219 106.15625 123.976562 105.109375 124.527344 104.078125 C 125.082031 103.046875 125.65625 102.03125 126.261719 101.027344 C 126.863281 100.023438 127.488281 99.035156 128.140625 98.0625 C 128.789062 97.089844 129.464844 96.132812 130.160156 95.191406 C 130.859375 94.253906 131.578125 93.332031 132.324219 92.425781 C 133.066406 91.523438 133.832031 90.636719 134.617188 89.769531 C 135.402344 88.902344 136.210938 88.054688 137.039062 87.226562 C 137.867188 86.398438 138.714844 85.59375 139.582031 84.808594 C 140.449219 84.023438 141.335938 83.257812 142.242188 82.515625 C 143.148438 81.773438 144.070312 81.054688 145.011719 80.355469 C 145.953125 79.660156 146.910156 78.988281 147.882812 78.335938 C 148.855469 77.6875 149.847656 77.0625 150.851562 76.460938 C 151.855469 75.859375 152.875 75.28125 153.90625 74.730469 C 154.941406 74.179688 155.984375 73.652344 157.042969 73.152344 C 158.101562 72.652344 159.171875 72.179688 160.253906 71.730469 C 161.335938 71.28125 162.429688 70.863281 163.53125 70.46875 C 164.636719 70.074219 165.746094 69.707031 166.867188 69.367188 C 167.988281 69.027344 169.117188 68.714844 170.253906 68.429688 C 171.386719 68.144531 172.53125 67.890625 173.679688 67.660156 C 174.828125 67.433594 175.980469 67.234375 177.140625 67.0625 C 178.296875 66.890625 179.460938 66.746094 180.625 66.632812 C 181.792969 66.519531 182.960938 66.429688 184.128906 66.375 C 185.300781 66.316406 186.46875 66.289062 187.640625 66.289062 C 188.8125 66.289062 189.980469 66.316406 191.152344 66.375 C 192.320312 66.429688 193.488281 66.519531 194.65625 66.632812 C 195.820312 66.746094 196.984375 66.890625 198.140625 67.0625 C 199.300781 67.234375 200.453125 67.433594 201.601562 67.660156 C 202.75 67.890625 203.894531 68.144531 205.027344 68.429688 C 206.164062 68.714844 207.292969 69.027344 208.414062 69.367188 C 209.535156 69.707031 210.644531 70.074219 211.75 70.46875 C 212.851562 70.863281 213.945312 71.28125 215.027344 71.730469 C 216.109375 72.179688 217.179688 72.652344 218.238281 73.152344 C 219.296875 73.652344 220.339844 74.179688 221.375 74.730469 C 222.40625 75.28125 223.425781 75.859375 224.429688 76.460938 C 225.433594 77.0625 226.425781 77.6875 227.398438 78.335938 C 228.371094 78.988281 229.328125 79.660156 230.269531 80.355469 C 231.210938 81.054688 232.132812 81.773438 233.039062 82.515625 C 233.945312 83.257812 234.832031 84.023438 235.699219 84.808594 C 236.566406 85.59375 237.414062 86.398438 238.242188 87.226562 C 239.070312 88.054688 239.878906 88.902344 240.664062 89.769531 C 241.449219 90.636719 242.214844 91.523438 242.957031 92.425781 C 243.703125 93.332031 244.421875 94.253906 245.121094 95.191406 C 245.816406 96.132812 246.492188 97.089844 247.140625 98.0625 C 247.792969 99.035156 248.417969 100.023438 249.019531 101.027344 C 249.625 102.03125 250.199219 103.046875 250.753906 104.078125 C 251.304688 105.109375 251.832031 106.15625 252.332031 107.214844 C 252.832031 108.269531 253.308594 109.339844 253.753906 110.421875 C 254.203125 111.503906 254.625 112.59375 255.019531 113.695312 C 255.414062 114.796875 255.78125 115.90625 256.121094 117.027344 C 256.460938 118.148438 256.773438 119.273438 257.058594 120.410156 C 257.34375 121.542969 257.597656 122.683594 257.828125 123.832031 C 258.054688 124.980469 258.257812 126.132812 258.429688 127.289062 C 258.601562 128.449219 258.742188 129.609375 258.859375 130.773438 C 258.972656 131.9375 259.058594 133.105469 259.117188 134.273438 C 259.171875 135.441406 259.203125 136.609375 259.203125 137.78125 C 259.199219 138.949219 259.171875 140.117188 259.109375 141.285156 C 259.050781 142.453125 258.964844 143.621094 258.847656 144.785156 C 258.730469 145.949219 258.585938 147.109375 258.414062 148.265625 C 258.242188 149.421875 258.039062 150.574219 257.808594 151.71875 C 257.578125 152.867188 257.320312 154.007812 257.035156 155.140625 C 256.75 156.277344 256.4375 157.402344 256.097656 158.519531 C 255.753906 159.640625 255.386719 160.75 254.992188 161.851562 C 254.597656 162.953125 254.175781 164.042969 253.726562 165.121094 C 253.277344 166.203125 252.800781 167.269531 252.300781 168.328125 C 251.800781 169.386719 251.273438 170.429688 250.71875 171.460938 C 250.167969 172.492188 249.589844 173.507812 248.988281 174.511719 C 248.386719 175.515625 247.757812 176.5 247.109375 177.472656 C 246.457031 178.445312 245.785156 179.402344 245.085938 180.339844 C 244.386719 181.28125 243.667969 182.203125 242.925781 183.105469 C 242.183594 184.007812 241.417969 184.894531 240.632812 185.761719 C 239.84375 186.628906 239.039062 187.472656 238.210938 188.300781 C 237.382812 189.128906 236.535156 189.933594 235.667969 190.71875 C 234.800781 191.503906 233.914062 192.269531 233.011719 193.011719 C 232.105469 193.753906 231.183594 194.472656 230.242188 195.171875 C 229.300781 195.867188 228.347656 196.539062 227.371094 197.191406 C 226.398438 197.839844 225.410156 198.46875 224.40625 199.070312 C 223.402344 199.671875 222.386719 200.246094 221.351562 200.800781 C 220.320312 201.351562 219.277344 201.878906 218.21875 202.378906 C 217.160156 202.878906 216.089844 203.351562 215.007812 203.800781 C 213.929688 204.25 212.835938 204.671875 211.734375 205.066406 C 210.632812 205.460938 209.523438 205.828125 208.402344 206.171875 C 207.28125 206.511719 206.152344 206.824219 205.019531 207.109375 C 203.882812 207.394531 202.742188 207.652344 201.59375 207.882812 C 200.445312 208.109375 199.292969 208.3125 198.136719 208.484375 C 196.976562 208.65625 195.816406 208.800781 194.652344 208.917969 C 193.488281 209.035156 192.320312 209.121094 191.152344 209.179688 C 189.980469 209.242188 188.8125 209.269531 187.640625 209.273438 Z M 187.640625 209.273438 " fill-opacity="1" fill-rule="nonzero"></path>
                                              </g>
                                          </svg></span>
                                      <span class="fs-4" style="
                                          position: relative;
                                          top: -5px;
                                          padding-left: 10px;
                                          display: block;
                                          line-height: 1.2;
                                      ">
                                          <strong data-translate-key="factory">FÁBRICA</strong><br>
                                          R dos minerais, 400 - Corredor Itaquaquecetuba - SP - CEP 08586-080
                                          
                                      </span>
                                  </div>  
    `

    if(mobile<992){
    footerColumnInfo.querySelector('.content-address').style.justifyContent = 'flex-start'
    }else{
        footerColumnInfo.querySelector('.content-address').style.justifyContent = 'flex-center'
    }

}

const headerActiveMenuItem = document.querySelectorAll('.header__active-menu-item')

document.addEventListener('DOMContentLoaded',()=>{
    if(headerActiveMenuItem){
        headerActiveMenuItem.forEach((h)=>{
            h.classList = '';
        })
    }
})

const HeaderMenuFale = document.querySelectorAll('#HeaderMenuFale, #HeaderDrawer-fale-conosco')
const HeaderMenuinstitucional = document.querySelectorAll('#HeaderMenu-institucional, #HeaderDrawer-institucional')
const HeaderMenuProdutos = document.querySelectorAll('#HeaderMenu-escolha-por, #HeaderDrawer-escolha-por')
const HeaderMenuleft = document.querySelectorAll('#HeaderMenu-escolha-por, #HeaderDrawer-escolha-por')

if(HeaderMenuFale){
    HeaderMenuFale.forEach((item)=>{
        item.setAttribute('data-menu-contact','false')
        item.setAttribute('data-menu','menu-fale-conosco')
        item.href = "#"
        item.addEventListener('click',(e)=>{
            e.preventDefault()
        })
    })
}

if(HeaderMenuinstitucional){
    HeaderMenuinstitucional.forEach((item)=>{
            item.setAttribute('data-menu-contact','false')
            item.setAttribute('data-menu','menu-institucional')
            item.href = "#"
            item.addEventListener('click',(e)=>{
                e.preventDefault()
            })        
    })
}

// if(HeaderMenuProdutos){
//     HeaderMenuProdutos.forEach((item)=>{
//             item.setAttribute('data-menu-contact','false')
//             item.setAttribute('data-menu','menu-produtos')
//             item.href = "#"
//             item.addEventListener('click',(e)=>{
//                 e.preventDefault()
//             })        
//     })
// }

if(HeaderMenuleft){
    HeaderMenuleft.forEach((item)=>{
            item.setAttribute('data-menu-left','false')
            item.href = "#"
            item.addEventListener('click',(e)=>{
                e.preventDefault()
            })        
    })
}




 const footerPageWidth = document.querySelector('.footer__content-top.page-width')
  let currentYear = new Date()

    if(footerPageWidth){
        footerPageWidth.classList.add('px-4')
        footerPageWidth.style.maxWidth = `${mobile>992 ? '95vw' : '85vw'}`       

        footerPageWidth.closest('footer').style.maxWidth = "2560px"
        footerPageWidth.closest('footer').style.paddingBottom = "0"
        footerPageWidth.closest('footer').classList.add('mx-auto')
        footerPageWidth.closest('#shopify-section-sections--25682908316013__footer').style.backgroundColor = "#dc1921"
    }

    const infoCompany = document.createElement('div')
    infoCompany.style.cssText = `
        padding: 18px 0;
        background-color: #000;
        margin-top: 30px;
    `

    infoCompany.innerHTML = `
       <div class="container">
            <div class="row justify-content-center">
                <div class="col-11 col-md-12 text-center" style="font-size: 0.75em;">
                    Copyright &copy ${currentYear.getFullYear()} São Bernardo - <span data-translate-key="footer_rights_text" style="margin-right: 4px;">Todos os direitos reservados | Desenvolvido com </span><span style="color: white;">❤</span> <span data-translate-key="copy_for">por</span> <a target="_blank" href="https://defoco.com.br/" rel="noopener"><u class="text-white">Defoco</u></a>
                </div>
            </div>
        </div>
    `

    footerPageWidth.closest('footer').appendChild(infoCompany)

    document.querySelector('.footer__copyright.caption').closest('.footer__content-bottom-wrapper.page-width').style.display = "none";

const blockFooterLinks = document.querySelectorAll('.footer-block')

    blockFooterLinks[0].classList.add('mw-block-0')
    blockFooterLinks[1].classList.add('mw-block-1')
    blockFooterLinks[2].classList.add('mw-block-2')
    blockFooterLinks[3].classList.add('mw-block-3')
    blockFooterLinks[4].classList.add('mw-block-4')

blockFooterLinks.forEach((block)=>{

        if(
            block.querySelector('.footer-block__heading').textContent === 'Entre em contato conosco' ||
            block.querySelector('.footer-block__heading').textContent === 'Contact us' ||
            block.querySelector('.footer-block__heading').textContent === 'Contáctanos' 
        ){
            block.innerHTML = `
               <h2 class="footer-block__heading inline-richtext">${block.querySelector('.footer-block__heading').textContent}</h2>
                    <ul class="footer-block__details-content list-unstyled">
                        <li>
                            <a href="mailto:atendimento@saobernardo.ind.br?cc=saobernardo@saobernardo.ind.br" class="link link--text list-menu__item list-menu__item--link p-0 m-0 d-flex align-items-center mb-3">
                                <span class="d-block">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" zoomAndPan="magnify" viewBox="0 0 37.5 37.500001" height="15" preserveAspectRatio="xMidYMid meet" version="1.2"><defs><clipPath id="c183493e8b"><path d="M 0 5 L 37.007812 5 L 37.007812 29.605469 L 0 29.605469 Z M 0 5 "></path></clipPath></defs><g id="4c9b6a21bd"><path style=" stroke:none;fill-rule:nonzero;fill:#ffffff;fill-opacity:1;" d="M 18.503906 14.582031 L 36.511719 3.332031 C 36.292969 2.835938 36.007812 2.382812 35.65625 1.96875 C 35.308594 1.558594 34.90625 1.203125 34.453125 0.910156 C 34 0.613281 33.511719 0.386719 32.992188 0.234375 C 32.476562 0.078125 31.945312 0 31.402344 0 L 5.601562 0 C 5.066406 0 4.539062 0.078125 4.023438 0.230469 C 3.507812 0.382812 3.023438 0.605469 2.574219 0.898438 C 2.121094 1.191406 1.722656 1.539062 1.371094 1.945312 C 1.019531 2.355469 0.734375 2.800781 0.511719 3.292969 Z M 18.503906 14.582031 "></path><g clip-rule="nonzero" clip-path="url(#c183493e8b)"><path style=" stroke:none;fill-rule:nonzero;fill:#ffffff;fill-opacity:1;" d="M 19.15625 17.082031 C 18.957031 17.207031 18.738281 17.269531 18.503906 17.269531 C 18.265625 17.269531 18.046875 17.207031 17.847656 17.082031 L 0 5.882812 L 0 24.003906 C 0 24.371094 0.0351562 24.734375 0.109375 25.09375 C 0.179688 25.457031 0.285156 25.804688 0.429688 26.144531 C 0.570312 26.484375 0.742188 26.808594 0.945312 27.113281 C 1.148438 27.417969 1.382812 27.703125 1.640625 27.960938 C 1.902344 28.222656 2.183594 28.457031 2.492188 28.660156 C 2.796875 28.863281 3.1216094 29.035156 3.460938 29.175781 C 3.800781 29.316406 4.148438 29.425781 4.511719 29.496094 C 4.871094 29.570312 5.234375 29.605469 5.601562 29.605469 L 31.402344 29.605469 C 31.773438 29.605469 32.136719 29.570312 32.496094 29.496094 C 32.855469 29.425781 33.207031 29.316406 33.546875 29.175781 C 33.886719 29.035156 34.210938 28.863281 34.515625 28.660156 C 34.820312 28.457031 35.105469 28.222656 35.363281 27.960938 C 35.625 27.703125 35.855469 27.417969 36.0625 27.113281 C 36.265625 26.808594 36.4375 26.484375 36.578125 26.144531 C 36.71875 25.804688 36.824219 25.457031 36.898438 25.09375 C 36.96875 24.734375 37.007812 24.371094 37.007812 24.003906 L 37.007812 5.925781 Z M 19.15625 17.082031 "></path></g></g></svg>
                                </span>
                                <span class="d-block position-relative" style="top: -3px;">
                                    atendimento@saobernardo.ind.br
                                </span>
                            </a>
                        </li>
                        <li class="mb-5 d-none">
                              <a href="mailto:saobernardo@saobernardo.ind.br" class="link link--text list-menu__item list-menu__item--link p-0 m-0 d-flex align-items-center">
                                <span class="d-block" style="opacity:0;">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" zoomAndPan="magnify" viewBox="0 0 37.5 37.500001" height="15" preserveAspectRatio="xMidYMid meet" version="1.2"><defs><clipPath id="c183493e8b"><path d="M 0 5 L 37.007812 5 L 37.007812 29.605469 L 0 29.605469 Z M 0 5 "></path></clipPath></defs><g id="4c9b6a21bd"><path style=" stroke:none;fill-rule:nonzero;fill:#ffffff;fill-opacity:1;" d="M 18.503906 14.582031 L 36.511719 3.332031 C 36.292969 2.835938 36.007812 2.382812 35.65625 1.96875 C 35.308594 1.558594 34.90625 1.203125 34.453125 0.910156 C 34 0.613281 33.511719 0.386719 32.992188 0.234375 C 32.476562 0.078125 31.945312 0 31.402344 0 L 5.601562 0 C 5.066406 0 4.539062 0.078125 4.023438 0.230469 C 3.507812 0.382812 3.023438 0.605469 2.574219 0.898438 C 2.121094 1.191406 1.722656 1.539062 1.371094 1.945312 C 1.019531 2.355469 0.734375 2.800781 0.511719 3.292969 Z M 18.503906 14.582031 "></path><g clip-rule="nonzero" clip-path="url(#c183493e8b)"><path style=" stroke:none;fill-rule:nonzero;fill:#ffffff;fill-opacity:1;" d="M 19.15625 17.082031 C 18.957031 17.207031 18.738281 17.269531 18.503906 17.269531 C 18.265625 17.269531 18.046875 17.207031 17.847656 17.082031 L 0 5.882812 L 0 24.003906 C 0 24.371094 0.0351562 24.734375 0.109375 25.09375 C 0.179688 25.457031 0.285156 25.804688 0.429688 26.144531 C 0.570312 26.484375 0.742188 26.808594 0.945312 27.113281 C 1.148438 27.417969 1.382812 27.703125 1.640625 27.960938 C 1.902344 28.222656 2.183594 28.457031 2.492188 28.660156 C 2.796875 28.863281 3.1216094 29.035156 3.460938 29.175781 C 3.800781 29.316406 4.148438 29.425781 4.511719 29.496094 C 4.871094 29.570312 5.234375 29.605469 5.601562 29.605469 L 31.402344 29.605469 C 31.773438 29.605469 32.136719 29.570312 32.496094 29.496094 C 32.855469 29.425781 33.207031 29.316406 33.546875 29.175781 C 33.886719 29.035156 34.210938 28.863281 34.515625 28.660156 C 34.820312 28.457031 35.105469 28.222656 35.363281 27.960938 C 35.625 27.703125 35.855469 27.417969 36.0625 27.113281 C 36.265625 26.808594 36.4375 26.484375 36.578125 26.144531 C 36.71875 25.804688 36.824219 25.457031 36.898438 25.09375 C 36.96875 24.734375 37.007812 24.371094 37.007812 24.003906 L 37.007812 5.925781 Z M 19.15625 17.082031 "></path></g></g></svg>
                                </span>
                                <span class="d-block position-relative" style="top: -3px;">
                                    saobernardo@saobernardo.ind.br
                                </span>
                            </a>
                        </li>
                        <li>
                            <a href="callto:+551126739052" class="link link--text list-menu__item list-menu__item--link p-0 m-0 d-flex align-items-center mb-1">
                                <span class="d-block">
                                <svg style="transform: rotate(10deg);" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" zoomAndPan="magnify" viewBox="0 0 31.92 37.500001" height="23" preserveAspectRatio="xMidYMid meet" version="1.2"><defs><clipPath id="67aa1018ab"><path d="M 0.171875 0.148438 L 31.257812 0.148438 L 31.257812 29.605469 L 0.171875 29.605469 Z M 0.171875 0.148438 "></path></clipPath></defs><g id="deb4d62498"><g clip-rule="nonzero" clip-path="url(#67aa1018ab)"><path style=" stroke:none;fill-rule:nonzero;fill:#ffffff;fill-opacity:1;" d="M 5.085938 0.625 C 4.222656 0.582031 3.453125 0.832031 2.78125 1.378906 C 1.929688 2.175781 1.28125 3.109375 0.832031 4.1875 C 0.386719 5.261719 0.179688 6.382812 0.214844 7.546875 C 0.324219 8.96875 0.636719 10.335938 1.160156 11.660156 C 1.683594 12.980469 2.390625 14.195312 3.285156 15.304688 L 3.472656 15.589844 C 5.078125 18.089844 6.996094 20.324219 9.226562 22.285156 C 11.460938 24.246094 13.921875 25.859375 16.609375 27.128906 C 19.046875 28.3125 21.617188 29.039062 24.316406 29.308594 C 24.800781 29.304688 25.28125 29.242188 25.75 29.121094 C 27.648438 28.726562 30.027344 27.308594 30.578125 25.730469 C 31.011719 24.683594 31.183594 23.601562 31.09375 22.472656 C 30.855469 22.335938 30.609375 22.210938 30.355469 22.097656 L 29.890625 21.859375 C 27.726562 20.824219 25.066406 19.515625 24.539062 19.308594 C 24.382812 19.261719 24.226562 19.238281 24.066406 19.234375 C 23.746094 19.230469 23.511719 19.367188 23.359375 19.648438 L 23.050781 20.09375 C 22.46875 20.945312 21.839844 21.761719 21.167969 22.546875 C 20.8125 22.894531 20.386719 23.113281 19.898438 23.203125 C 19.410156 23.292969 18.9375 23.242188 18.480469 23.046875 L 18.242188 22.9375 C 15.882812 21.988281 13.765625 20.65625 11.886719 18.945312 C 10.082031 17.28125 8.554688 15.390625 7.3125 13.277344 C 7.191406 13.082031 7.105469 12.871094 7.0625 12.648438 C 7.015625 12.421875 7.011719 12.195312 7.042969 11.96875 C 7.078125 11.742188 7.152344 11.53125 7.261719 11.328125 C 7.375 11.128906 7.515625 10.953125 7.6875 10.800781 C 7.914062 10.511719 8.164062 10.242188 8.433594 9.992188 C 8.574219 9.804688 8.746094 9.65625 8.890625 9.476562 C 9.210938 9.152344 9.476562 8.785156 9.6875 8.378906 C 9.773438 8.070312 9.734375 7.78125 9.5625 7.511719 C 9.40625 7.230469 8.773438 5.628906 7.835938 3.402344 L 7.101562 1.574219 C 6.722656 0.65625 6.609375 0.644531 5.960938 0.644531 L 5.738281 0.644531 C 5.546875 0.636719 5.308594 0.625 5.085938 0.625 Z M 5.085938 0.625 "></path></g></g></svg>
                                </span>
                                <span class="fs-3 d-block position-relative" style="top: -3px;">
                                 <strong data-translate-key="office_label" style="
                                     font-weight: 100;
                                     margin-right: 1px;
                                 ">Escritório:</strong>
                                 (11) 2673-9052
                                </span>
                            </a>
                        </li>
                        <li>
                            <a href="callto:+551146462929" class="link link--text list-menu__item list-menu__item--link p-0 m-0 d-flex align-items-center">
                                <span class="d-block" style="opacity: 0;">
                                <svg style="transform: rotate(10deg);" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" zoomAndPan="magnify" viewBox="0 0 31.92 37.500001" height="23" preserveAspectRatio="xMidYMid meet" version="1.2"><defs><clipPath id="67aa1018ab"><path d="M 0.171875 0.148438 L 31.257812 0.148438 L 31.257812 29.605469 L 0.171875 29.605469 Z M 0.171875 0.148438 "></path></clipPath></defs><g id="deb4d62498"><g clip-rule="nonzero" clip-path="url(#67aa1018ab)"><path style=" stroke:none;fill-rule:nonzero;fill:#ffffff;fill-opacity:1;" d="M 5.085938 0.625 C 4.222656 0.582031 3.453125 0.832031 2.78125 1.378906 C 1.929688 2.175781 1.28125 3.109375 0.832031 4.1875 C 0.386719 5.261719 0.179688 6.382812 0.214844 7.546875 C 0.324219 8.96875 0.636719 10.335938 1.160156 11.660156 C 1.683594 12.980469 2.390625 14.195312 3.285156 15.304688 L 3.472656 15.589844 C 5.078125 18.089844 6.996094 20.324219 9.226562 22.285156 C 11.460938 24.246094 13.921875 25.859375 16.609375 27.128906 C 19.046875 28.3125 21.617188 29.039062 24.316406 29.308594 C 24.800781 29.304688 25.28125 29.242188 25.75 29.121094 C 27.648438 28.726562 30.027344 27.308594 30.578125 25.730469 C 31.011719 24.683594 31.183594 23.601562 31.09375 22.472656 C 30.855469 22.335938 30.609375 22.210938 30.355469 22.097656 L 29.890625 21.859375 C 27.726562 20.824219 25.066406 19.515625 24.539062 19.308594 C 24.382812 19.261719 24.226562 19.238281 24.066406 19.234375 C 23.746094 19.230469 23.511719 19.367188 23.359375 19.648438 L 23.050781 20.09375 C 22.46875 20.945312 21.839844 21.761719 21.167969 22.546875 C 20.8125 22.894531 20.386719 23.113281 19.898438 23.203125 C 19.410156 23.292969 18.9375 23.242188 18.480469 23.046875 L 18.242188 22.9375 C 15.882812 21.988281 13.765625 20.65625 11.886719 18.945312 C 10.082031 17.28125 8.554688 15.390625 7.3125 13.277344 C 7.191406 13.082031 7.105469 12.871094 7.0625 12.648438 C 7.015625 12.421875 7.011719 12.195312 7.042969 11.96875 C 7.078125 11.742188 7.152344 11.53125 7.261719 11.328125 C 7.375 11.128906 7.515625 10.953125 7.6875 10.800781 C 7.914062 10.511719 8.164062 10.242188 8.433594 9.992188 C 8.574219 9.804688 8.746094 9.65625 8.890625 9.476562 C 9.210938 9.152344 9.476562 8.785156 9.6875 8.378906 C 9.773438 8.070312 9.734375 7.78125 9.5625 7.511719 C 9.40625 7.230469 8.773438 5.628906 7.835938 3.402344 L 7.101562 1.574219 C 6.722656 0.65625 6.609375 0.644531 5.960938 0.644531 L 5.738281 0.644531 C 5.546875 0.636719 5.308594 0.625 5.085938 0.625 Z M 5.085938 0.625 "></path></g></g></svg>
                                </span>
                                <span class="fs-3 d-block position-relative" style="top: -3px;">
                                <strong data-translate-key="factory_label" style="
                                 font-weight: 100;
                                 margin-right: 1px;
                                ">Fábrica:</strong>
                                (11) 4646-2929
                                </span>
                            </a>                            
                        </li>
                          <li class="mb-5">
                                <a href="https://api.whatsapp.com/send?phone=5511932160215" class="link link--text list-menu__item list-menu__item--link p-0 m-0 d-flex align-items-center">
                                    <span class="d-block" style="opacity: 0;">
                                    <svg style="transform: rotate(10deg);" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" zoomAndPan="magnify" viewBox="0 0 31.92 37.500001" height="23" preserveAspectRatio="xMidYMid meet" version="1.2"><defs><clipPath id="67aa1018ab"><path d="M 0.171875 0.148438 L 31.257812 0.148438 L 31.257812 29.605469 L 0.171875 29.605469 Z M 0.171875 0.148438 "></path></clipPath></defs><g id="deb4d62498"><g clip-rule="nonzero" clip-path="url(#67aa1018ab)"><path style=" stroke:none;fill-rule:nonzero;fill:#ffffff;fill-opacity:1;" d="M 5.085938 0.625 C 4.222656 0.582031 3.453125 0.832031 2.78125 1.378906 C 1.929688 2.175781 1.28125 3.109375 0.832031 4.1875 C 0.386719 5.261719 0.179688 6.382812 0.214844 7.546875 C 0.324219 8.96875 0.636719 10.335938 1.160156 11.660156 C 1.683594 12.980469 2.390625 14.195312 3.285156 15.304688 L 3.472656 15.589844 C 5.078125 18.089844 6.996094 20.324219 9.226562 22.285156 C 11.460938 24.246094 13.921875 25.859375 16.609375 27.128906 C 19.046875 28.3125 21.617188 29.039062 24.316406 29.308594 C 24.800781 29.304688 25.28125 29.242188 25.75 29.121094 C 27.648438 28.726562 30.027344 27.308594 30.578125 25.730469 C 31.011719 24.683594 31.183594 23.601562 31.09375 22.472656 C 30.855469 22.335938 30.609375 22.210938 30.355469 22.097656 L 29.890625 21.859375 C 27.726562 20.824219 25.066406 19.515625 24.539062 19.308594 C 24.382812 19.261719 24.226562 19.238281 24.066406 19.234375 C 23.746094 19.230469 23.511719 19.367188 23.359375 19.648438 L 23.050781 20.09375 C 22.46875 20.945312 21.839844 21.761719 21.167969 22.546875 C 20.8125 22.894531 20.386719 23.113281 19.898438 23.203125 C 19.410156 23.292969 18.9375 23.242188 18.480469 23.046875 L 18.242188 22.9375 C 15.882812 21.988281 13.765625 20.65625 11.886719 18.945312 C 10.082031 17.28125 8.554688 15.390625 7.3125 13.277344 C 7.191406 13.082031 7.105469 12.871094 7.0625 12.648438 C 7.015625 12.421875 7.011719 12.195312 7.042969 11.96875 C 7.078125 11.742188 7.152344 11.53125 7.261719 11.328125 C 7.375 11.128906 7.515625 10.953125 7.6875 10.800781 C 7.914062 10.511719 8.164062 10.242188 8.433594 9.992188 C 8.574219 9.804688 8.746094 9.65625 8.890625 9.476562 C 9.210938 9.152344 9.476562 8.785156 9.6875 8.378906 C 9.773438 8.070312 9.734375 7.78125 9.5625 7.511719 C 9.40625 7.230469 8.773438 5.628906 7.835938 3.402344 L 7.101562 1.574219 C 6.722656 0.65625 6.609375 0.644531 5.960938 0.644531 L 5.738281 0.644531 C 5.546875 0.636719 5.308594 0.625 5.085938 0.625 Z M 5.085938 0.625 "></path></g></g></svg>
                                    </span>
                                    <span class="fs-3 d-block position-relative" style="top: -3px;">
                                    WhatsApp: (11) 9 3216-0215
                                    </span>
                                </a>                            
                          </li>
                        <li>
                                <div class="row gap-y-3 ps-3">
                                    <div class="col-12">
                                        <a href="/" class="link-faded">
                                            <img src="https://cdn.shopify.com/s/files/1/0956/4202/6349/files/logo-sao-bernardo-2025-v1.png?v=1761684868"
                                            alt="{{ shop.title }}"
                                            class="img-fluid d-block mt-5"
                                            width="200"
                                            loading="lazy">
                                        </a>
                                    </div>                
                                    <div class="col-12">
                                        <p class="fs-5 text-white" data-translate-key="brand_commitment_paragraph">
                                            Nosso compromisso vai além de produzir itens de qualidade. Criamos soluções alinhadas às tendências do mercado nacional e internacional, combinado design moderno, funcionalidade e inovação.
                                        </p>
                                    </div>
                                </div>
                        </li>
                    </ul>
            `
        }

        if(
            block.querySelector('.footer-block__heading').textContent === 'Loja' ||
            block.querySelector('.footer-block__heading').textContent === 'Store' ||
            block.querySelector('.footer-block__heading').textContent === 'Almacenar' 
        ){

            block.innerHTML = `
            <h2 class="footer-block__heading inline-richtext">${block.querySelector('.footer-block__heading').textContent}</h2>
                <ul class="footer-block__details-content list-unstyled double-collum">
                <li>
                    <a href="${siteUrl}/collections/lancamentos" class="link link--text list-menu__item list-menu__item--link">
                    Lançamentos
                    </a>
                    <a href="${siteUrl}/collections/caixas-organizadoras" class="link link--text list-menu__item list-menu__item--link">
                    Caixas organizadoras
                    </a>
                </li>
                <li>
                    <a href="${siteUrl}/collections/organizadores" class="link link--text list-menu__item list-menu__item--link">
                    Organizadores
                    </a>
                    <a href="${siteUrl}/collections/rattan" class="link link--text list-menu__item list-menu__item--link">
                    Rattan
                    </a>
                </li>
                <li>
                    <a href="${siteUrl}/collections/linha-premium" class="link link--text list-menu__item list-menu__item--link">
                    Linha Premium
                    </a>
                    <a href="${siteUrl}/collections/gaveteiros" class="link link--text list-menu__item list-menu__item--link">
                    Gaveteiros
                    </a>
                </li>
              
                <li>
                    <a href="${siteUrl}/collections/fruteira" class="link link--text list-menu__item list-menu__item--link">
                    Fruteira
                    </a>
                    <a href="${siteUrl}/collections/pipoqueiras" class="link link--text list-menu__item list-menu__item--link">
                    Pipoqueiras
                    </a>
                </li>
                <li>
                    <a href="${siteUrl}/collections/linha-banheiro" class="link link--text list-menu__item list-menu__item--link">
                    Linha Banheiro
                    </a>
                    <a href="${siteUrl}/collections/copos" class="link link--text list-menu__item list-menu__item--link">
                    Copos
                    </a>
                </li>
                <li>
                    <a href="${siteUrl}/collections/caixa-de-utilidades" class="link link--text list-menu__item list-menu__item--link">
                    Caixa de utilidades
                    </a>
                    <a href="${siteUrl}/collections/garrafas" class="link link--text list-menu__item list-menu__item--link">
                    Garrafas
                    </a>
                </li>
                <li>
                    <a href="${siteUrl}/collections/pet" class="link link--text list-menu__item list-menu__item--link">
                    Pet
                    </a>
                    <a href="${siteUrl}/collections/caixa-de-ferramenta" class="link link--text list-menu__item list-menu__item--link">
                    Caixa de Ferramenta
                    </a>
                </li>
                <li>
                    <a href="${siteUrl}/collections/porta-cosmeticos" class="link link--text list-menu__item list-menu__item--link">
                    Porta cosméticos
                    </a>
                    <a href="${siteUrl}/collections/organizadores" class="link link--text list-menu__item list-menu__item--link">
                    Organizadores
                    </a>
                </li>
                <li>
                    <a href="${siteUrl}/collections/lavanderia" class="link link--text list-menu__item list-menu__item--link">
                    Lavanderia
                    </a>
                    <a href="${siteUrl}/collections/prateleiras" class="link link--text list-menu__item list-menu__item--link">
                    Prateleiras
                    </a>
                </li>
                <li>
                    <a href="${siteUrl}/collections/cabide" class="link link--text list-menu__item list-menu__item--link">
                    Cabide
                    </a>
                </li>
                </ul>

            `

             block.querySelectorAll('li a').forEach((a)=>{
                a.classList.add('list-sytle-link')
            })

        }

        if(
            block.querySelector('.footer-block__heading').textContent === 'Segurança' ||
            block.querySelector('.footer-block__heading').textContent === 'Security'  ||
            block.querySelector('.footer-block__heading').textContent === 'Seguridad' 
          ){
            block.innerHTML = `
            <h2 class="footer-block__heading inline-richtext">${block.querySelector('.footer-block__heading').textContent}</h2>
            <ul class="footer-block__details-content list-unstyled">
                <li>
                    <a href="https://transparencyreport.google.com/safe-browsing/search?url=https:%2F%2Fwww.saobernardo.ind.br%2F&hl=pt_BR" class="link link--text list-menu__item list-menu__item--link" target="_blank">
                        <img 
                        src="https://cdn.shopify.com/s/files/1/0956/4202/6349/files/google-safe-browsing.png?v=1762280808"
                        width="110"
                        alt="São Bernardo Google Safe Browser"
                        class="img-fluid">
                    </a>
                </li>
            </ul>
            `
        }

        if(
            block.querySelector('.footer-block__heading').textContent === 'Redes Sociais' ||
            block.querySelector('.footer-block__heading').textContent === 'Social media' ||
            block.querySelector('.footer-block__heading').textContent === 'Redes sociales'
        ){
            block.innerHTML = `
            <h2 class="footer-block__heading inline-richtext">${block.querySelector('.footer-block__heading').textContent}</h2>
            <ul class="footer-block__details-content list-unstyled" style="    
            display: flex;
            align-items: baseline;">
                <li class="d-none">
                    <a href="#" class="link link--text list-menu__item list-menu__item--link">
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="22px" height="22px" fill="white"><path d="M25,3C12.85,3,3,12.85,3,25c0,11.03,8.125,20.137,18.712,21.728V30.831h-5.443v-5.783h5.443v-3.848 c0-6.371,3.104-9.168,8.399-9.168c2.536,0,3.877,0.188,4.512,0.274v5.048h-3.612c-2.248,0-3.033,2.131-3.033,4.533v3.161h6.588 l-0.894,5.783h-5.694v15.944C38.716,45.318,47,36.137,47,25C47,12.85,37.15,3,25,3z"/></svg>
                        </span>
                    </a>
                </li>
                <li>
                    <a href="https://www.instagram.com/saobernardo.plasticos/" class="link link--text list-menu__item list-menu__item--link" target="_blank">
                        <span>
                            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z" fill="#ffffff"></path> <path d="M18 5C17.4477 5 17 5.44772 17 6C17 6.55228 17.4477 7 18 7C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5Z" fill="#ffffff"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M1.65396 4.27606C1 5.55953 1 7.23969 1 10.6V13.4C1 16.7603 1 18.4405 1.65396 19.7239C2.2292 20.8529 3.14708 21.7708 4.27606 22.346C5.55953 23 7.23969 23 10.6 23H13.4C16.7603 23 18.4405 23 19.7239 22.346C20.8529 21.7708 21.7708 20.8529 22.346 19.7239C23 18.4405 23 16.7603 23 13.4V10.6C23 7.23969 23 5.55953 22.346 4.27606C21.7708 3.14708 20.8529 2.2292 19.7239 1.65396C18.4405 1 16.7603 1 13.4 1H10.6C7.23969 1 5.55953 1 4.27606 1.65396C3.14708 2.2292 2.2292 3.14708 1.65396 4.27606ZM13.4 3H10.6C8.88684 3 7.72225 3.00156 6.82208 3.0751C5.94524 3.14674 5.49684 3.27659 5.18404 3.43597C4.43139 3.81947 3.81947 4.43139 3.43597 5.18404C3.27659 5.49684 3.14674 5.94524 3.0751 6.82208C3.00156 7.72225 3 8.88684 3 10.6V13.4C3 15.1132 3.00156 16.2777 3.0751 17.1779C3.14674 18.0548 3.27659 18.5032 3.43597 18.816C3.81947 19.5686 4.43139 20.1805 5.18404 20.564C5.49684 20.7234 5.94524 20.8533 6.82208 20.9249C7.72225 20.9984 8.88684 21 10.6 21H13.4C15.1132 21 16.2777 20.9984 17.1779 20.9249C18.0548 20.8533 18.5032 20.7234 18.816 20.564C19.5686 20.1805 20.1805 19.5686 20.564 18.816C20.7234 18.5032 20.8533 18.0548 20.9249 17.1779C20.9984 16.2777 21 15.1132 21 13.4V10.6C21 8.88684 20.9984 7.72225 20.9249 6.82208C20.8533 5.94524 20.7234 5.49684 20.564 5.18404C20.1805 4.43139 19.5686 3.81947 18.816 3.43597C18.5032 3.27659 18.0548 3.14674 17.1779 3.0751C16.2777 3.00156 15.1132 3 13.4 3Z" fill="#ffffff"></path> </g></svg>
                        </span>
                    </a>
                </li>
                <li class="d-none">
                    <a href="#" class="link link--text list-menu__item list-menu__item--link">
                        <span>
                             <svg width="20px" height="20px" viewBox="0 -3 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#ffffff" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>youtube [#168]</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Dribbble-Light-Preview" transform="translate(-300.000000, -7442.000000)" fill="#ffffff"> <g id="icons" transform="translate(56.000000, 160.000000)"> <path d="M251.988432,7291.58588 L251.988432,7285.97425 C253.980638,7286.91168 255.523602,7287.8172 257.348463,7288.79353 C255.843351,7289.62824 253.980638,7290.56468 251.988432,7291.58588 M263.090998,7283.18289 C262.747343,7282.73013 262.161634,7282.37809 261.538073,7282.26141 C259.705243,7281.91336 248.270974,7281.91237 246.439141,7282.26141 C245.939097,7282.35515 245.493839,7282.58153 245.111335,7282.93357 C243.49964,7284.42947 244.004664,7292.45151 244.393145,7293.75096 C244.556505,7294.31342 244.767679,7294.71931 245.033639,7294.98558 C245.376298,7295.33761 245.845463,7295.57995 246.384355,7295.68865 C247.893451,7296.0008 255.668037,7296.17532 261.506198,7295.73552 C262.044094,7295.64178 262.520231,7295.39147 262.895762,7295.02447 C264.385932,7293.53455 264.28433,7285.06174 263.090998,7283.18289" id="youtube-[#168]"> </path> </g> </g> </g> </g></svg>
                        </span>
                    </a>
                </li>
                <li class="d-none">
                    <a href="#" class="link link--text list-menu__item list-menu__item--link">
                        <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="20px" fill="white" class="bi bi-twitter-x" viewBox="0 0 16 16"><path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"></path></svg>
                        </span>
                    </a>
                </li>
            </ul>
            `
        }

        if(
          block.querySelector('.footer-block__heading').textContent === 'informações' ||
          block.querySelector('.footer-block__heading').textContent === 'información' ||
          block.querySelector('.footer-block__heading').textContent === 'information' 
          ){
            block.querySelectorAll('a').forEach(a =>{
                if(
                a && (a.textContent.trim() === 'Contato' || a.textContent.trim() === 'Contact' || a.textContent.trim() === 'Contacto')){
                    a.href = '#'
                    a.setAttribute('data-menu-contact','false')
                    a.setAttribute('data-menu','menu-fale-conosco')
                    a.addEventListener('click',(e)=>{                       
                        e.preventDefault()                        
                    })
                }
            })
        }

})





